// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/home-video-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets//images/redefineKidz.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/give-banner-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/group-page-top-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/serve.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/redefine-kids-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/about-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/group-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/kids.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/bar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-light-theme {
    --widget-bg: #fff;
    --sermon-heading: #000;
    --notification-menu: #fff;
    --noti-cont-shadow: 1px 1px 10px gray;
    --chat-head-bg: #fff;
    --song-cont-bg: #d8d8d8;
    --selected-event: rgba(255, 255, 255, 0.85);
    --event-item-shadow: 1px 1px 10px #d1d1d1;
    --shortcut-menu-bg: #fff;
    --shoutcut-cont-bg: #818181;
    --fc-button-primary: rgb(0 0 0 / 60%);
    --fc-button-primary-dis: rgb(0 0 0 / 80%);
}
.widget-dark-theme {
    --widget-bg: #151515;
    --sermon-heading: #fff;
    --notification-menu: #080808;
    --noti-cont-shadow: unset;
    --chat-head-bg: #323232;
    --song-cont-bg: #1d1e1e;
    --selected-event: unset;
    --event-item-shadow: unset;
    --shortcut-menu-bg: #080808;
    --shoutcut-cont-bg: #18191a;
    --fc-button-primary: rgb(255 255 255 / 0.1);
    --fc-button-primary-dis: rgb(255 255 255 / 0.3);
}

.sharp-mode {
    --max-width: 100%;
    --width: calc(100%);
}

.round-mode {
    --max-width: 95%;
    --width: calc(95%);
}

body {
    margin: 0;
    padding: 0;
    background-color: #080808;
    overflow-x: hidden;
}

html {
    /* background-color: #080808 !important; */
    overflow-x: hidden !important;
}

.rightWrapMain {
    width: var(--width);
    padding-top: 20px;
    overflow-y: auto;
}

@media (max-width: 500px) {
    .rightWrapMain {
        width: 90% !important;
    }
}

.rightWrapMain::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.mainWrapper {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    /* height: 100vh; */
    min-height: 100vh;
}
.video-banner-bg {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover
        no-repeat;
    height: 450px;
    border-radius: 20px;
}
.banner-title h2 {
    color: #fff;
    font-size: 40px;
    line-height: 54px;
    font-family: "frontageregular";
}
.video-banner-bg {
    display: flex;
    align-items: flex-end;
    padding: 20px;
    position: relative;
}
.tag-name {
    display: table;
    position: relative;
}
.tag-name h4 {
    margin: 0;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    padding: 8px 16px;
    position: relative;
    z-index: 10;
}
.blur-bg {
    background: rgb(150 150 150 / 40%);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
    filter: blur(0.8px);
    border-radius: 3px;
}
.banner-title {
    margin-top: 10px;
}
.play-btn {
    position: absolute;
    z-index: 12;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.play-btn i {
    color: #fff;
    font-size: 100px;
}
.messages-list {
    height: 84%;
    overflow: hidden;
}
.messages-list {
    height: 84%;
    overflow: hidden;
    padding: 20px;
}
.messages-list ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
.messages-list li span {
    color: #3478ff;
    font-family: "frontageregular";
    opacity: 1;
    margin-bottom: 1px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    display: block;
}
.messages-list li {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    opacity: 0.6;
    font-size: 15px;
    line-height: 22px;
}
.messages-list li + li {
    margin-top: 15px;
}
.typing-msg {
    border-top: 1px solid rgb(255 255 255 / 10%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 16%;
    padding: 0 20px;
}
.typbox input {
    background: 0 0;
    border: none;
    outline: 0;
    font-family: "Open Sans", sans-serif;
    padding: 0;
    color: #fff;
    opacity: 0.6;
}
.typbox {
    width: 70%;
}
.btn-submit {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.btn-submit input {
    width: auto;
    background: #3478ff;
    border: none;
    color: #fff;
    padding: 6px 20px;
    outline: 0;
    display: flex;
}
.take-note-field textarea {
    background: 0 0;
    width: 100%;
    height: 100%;
    outline: 0;
    border: none;
    padding: 25px;
    resize: none;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    height: 100%;
}
.take-note-field {
    height: 100%;
}
.take-notes-inner {
    height: 100%;
    background: #171717;
    border-radius: 20px 0 0 20px;
}
.editdeletebtn {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    opacity: 0;
}
.hover-div {
    /* ... existing styles */
    transition: all 0.3s ease; /* Adjust duration and timing as needed */
}
.hovered {
    /* ... existing hover styles */
    opacity: 1;
}

.sidebaroption.hide,
.sidebaroption2.hide {
    display: none;
}

.custom-widgetMain.show {
    display: block;
}
.editbtn {
    margin-left: 12px;
}
.msg-inner-box {
    position: relative;
}
.editdeletebtn img {
    cursor: pointer;
}
.bluegradientmain {
    padding: 15px 30px 15px 30px;
    position: relative;
    border-radius: 20px;
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    overflow-y: auto;
    overflow-x: hidden;
}

.bluegradientmain::-webkit-scrollbar {
    width: 4px !important;
    display: none !important;
}

.bluegradientmain::-webkit-scrollbar-track {
    background: transparent; /* Color of the track */
}
.bluegradientmain::-webkit-scrollbar-thumb {
    background: #414040; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
.edit-mode {
    outline: 4px dashed #d60909;
}

.videoCont {
    border-radius: 20px;
    height: 100%;
    width: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.videoDiv {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    height: 100%;
    width: 100%;
    border-radius: 20px;
    background-position: center;
    background-repeat: no-repeat;
}

.aspect-ratio-box {
    height: 0;
    overflow: hidden;
    padding-top: 56.25%;
    background: white;
    position: relative;
    border-radius: 20px;
}
.aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
}

/* For controls panel customization*/
/* video::-webkit-media-controls-panel {
  background-image: none !important;
  margin-bottom: 30px;
 } */

.imgBg {
    /* background-image: url(../../assets//images/blackBg.jpg); */
    padding: 30px;
    position: relative;
    border-radius: 20px;
    width: 100%;
    /* height: calc(328px * 2 + 25px); */
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-user-select: none;
            user-select: none;
}

h2.quoteText {
    font-size: 40px;
    color: #ffffff;
    text-align: center;
}

h2.maintitle {
    color: #fff;
    font-size: 34px;
    line-height: 44px;
    font-family: "frontageregular";
}
.sec2 {
    margin-top: 30px;
}
.give-form input {
    background: 0 0;
    border: none;
    outline: 0;
    border-bottom: 1px solid #fff;
    border-radius: 0;
    padding: 12px 0;
    width: 100%;
    color: #fff;
    font-size: 13px;
    padding: 15px 0;
    /* margin-bottom: 18px; */
}

.logout-textarea {
    background: 0 0;
    border: none;
    outline: 0;
    border-bottom: 1px solid #fff;
    border-radius: 0;
    padding: 12px 0;
    width: 100%;
    color: #fff;
    font-size: 13px;
    padding: 15px 0;
    max-height: 120px;
}

.giving-btn-cont {
    margin-top: 1rem;
}

.donated-amount {
    color: #fb5f5f;
    font-weight: 600;
    letter-spacing: 4px;
    margin: 0;
    opacity: 0.9;
}

.payment-method-cont {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
    background-color: #f46363;
    border-radius: 12px;
    row-gap: 6px;
    min-height: 86px;
    position: relative;
}

.freq-goal-cont {
    border-radius: 5px;
    padding-block: 6px;
    padding-inline: 14px;
    cursor: pointer;
}

.giving-mobile::-webkit-scrollbar {
    display: none;
}

.chat-bubble {
    max-width: 70% !important;
}

.chatHead-chat-bubble {
    max-width: 90% !important;
}

@media (max-width: 468px) {
    .logout-textarea {
        margin: 0 !important;
        padding-bottom: 0 !important;
    }
    .bluegradientmain {
        zoom: 90% !important;
    }
    .bluegradientmain-mobile {
        padding: 12px !important;
    }
    .giving-mobile {
        padding: 10px !important;
        overflow: auto;
    }
    .pinkgradient {
        zoom: 90% !important;
    }
    .giving-amount-field {
        padding: 0 !important;
    }
    .giving-btn-cont {
        margin-top: 0.25rem;
    }
    .donated-amount {
        line-height: 1.2;
        font-size: 36px !important;
    }
    .songs-list {
        padding: 12px !important;
        zoom: 90%;
    }
    .calendar,
    .team-detail {
        zoom: 80%;
    }
    .fc-col-header {
        width: 100% !important;
    }
    .fc-scrollgrid-sync-table,
    .fc-daygrid-body-unbalanced {
        width: 100% !important;
    }
    .team-member {
        zoom: 90%;
        padding: 10px !important;
    }
    .profile-name {
        margin-top: 0 !important;
    }
    .givingPaddingFlag {
        padding: 10px !important;
    }
    .subscription-text {
        font-size: 10px !important;
    }
    .reoccuringGifts {
        height: 80px !important;
    }
    .payment-method-cont,
    .ach-card-cont {
        min-height: 56px !important;
        padding: 6px !important;
        border-radius: 6px !important;
    }
    .givingGoal,
    .joinGroup {
        padding: 10px !important;
    }
    .freq-goal-cont {
        padding-inline: 8px;
    }
    .profileText h4 {
        line-height: 1.4 !important;
    }
    .chat-bubble {
        max-width: 98% !important;
    }
}

/* Customize the scrollbar width */
textarea::-webkit-scrollbar {
    width: 6px; /* Width of the entire scrollbar */
}
/* Customize the track (the background of the scrollbar) */
textarea::-webkit-scrollbar-track {
    background: transparent; /* Color of the track */
}
/* Customize the thumb (the draggable part of the scrollbar) */
textarea::-webkit-scrollbar-thumb {
    background: #696767; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
/* Customize the thumb when hovered */
textarea::-webkit-scrollbar-thumb:hover {
    background: #555; /* Color of the thumb on hover */
}

textarea::-webkit-input-placeholder {
    color: #fff;
}

/* Customize the scrollbar width */
body::-webkit-scrollbar {
    width: 4px; /* Width of the entire scrollbar */
}
/* Customize the track (the background of the scrollbar) */
body::-webkit-scrollbar-track {
    background: transparent; /* Color of the track */
}
/* Customize the thumb (the draggable part of the scrollbar) */
body::-webkit-scrollbar-thumb {
    background: #696767; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
/* Customize the thumb when hovered */
body::-webkit-scrollbar-thumb:hover {
    background: #555; /* Color of the thumb on hover */
}

body::-webkit-input-placeholder {
    color: #fff;
}

.give-content3-inner.home-about-form .give-form input {
    padding: 15px 0;
    margin-bottom: 18px;
}
.submit-btn-give input {
    background: #fff;
    font-size: 18px;
    padding: 4px 20px !important;
    border-radius: 2px;
    letter-spacing: -2px;
    width: auto;
    margin-top: 10px;
    color: #397bfe;
    margin-bottom: 0 !important;
    font-family: "frontageregular";
    border-radius: 7px;
}
.give-form input::placeholder {
    color: #fff;
}
.welcomForm.give-form {
    /* margin-top: 30px; */
}
.pinkgradient {
    /* background: #f8acac; */
    /* background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%); */
    position: relative;
    border-radius: 20px;
    /* overflow: hidden; */
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    flex-direction: column;
    padding: 20px;
    overflow-y: auto;
}
.pinkgradient::-webkit-scrollbar {
    display: none;
    /* width:0.5rem; */
}

.welcomForm.give-form .formField.halffield {
    width: 40%;
}

.amount-Input {
    border-bottom: 1px solid #fff;
    align-items: center;
    column-gap: 10px;
}

.welcomForm.give-form .submit-btn-give.halffield {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.fullfield {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.submit-btn-give.halffield input {
    margin: 0 0 18px;
    color: #fb7878;
}
.pinkTop {
    /* padding: 0 20px 0 20px; */
    padding: 20px;
    height: 40%;
    /* padding-bottom: 15px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.whitebottom {
    height: 60%;
    background: #fff;
    padding: 10px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.contentcenter {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    height: 100%;
    /* margin-left: 60px; */
    justify-content: space-between;
}

.contentcenter h2 {
    color: #fb6d6d;
    font-size: 60px;
    line-height: 74px;
    font-family: "frontageregular";
}

.contentcenter h3 {
    color: #fb6d6d;
    font-size: 30px;
    line-height: 44px;
    font-family: "frontageregular";
}

.contentcenter h6 {
    color: #000;
    font-weight: 600;
    font-size: 18px;
    margin-top: 15px;
}
.progessbar {
    width: 60px;
    height: 90%;
    background: rgb(23 23 23 / 20%);
    position: absolute;
    top: 0;
    border-radius: 10px;
    top: 5%;
    overflow: hidden;
}

.whitebottom {
    position: relative;
}

.progessbar:before {
    content: "";
    background: #f8acac;
    background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%);
    width: 100%;
    height: 80%;
    position: absolute;
    bottom: 0;
    left: 0;
}
.sec3 {
    margin-top: 30px;
}
.purplegradientmain {
    /* background: #d5afff; */
    /* background: linear-gradient(149deg, #d5afff 0, #9d53f1 100%); */
    padding: 30px;
    position: relative;
    border-radius: 20px;
    transition: background-image 0.5s ease, background-size 0.5s ease;
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
    /* background-image: url(../../assets/images/mapDiv.png); */
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
/* .purplegradientmain:hover {
  background-image: url(../../assets//images/map.png);
  background-size: cover;
} */

.joinGroup {
    background: #d5afff;
    /* background: linear-gradient(149deg, #d5afff 0, #9d53f1 100%); */
    padding: 30px;
    position: relative;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.eventList {
    background: #f57b4f;
    /* background: linear-gradient(149deg, #f57b4f 0, #d94d2e 100%); */
    padding: 30px;
    position: relative;
    border-radius: 20px;
    display: flex;
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: auto;
}

.eventList::-webkit-scrollbar {
    display: none;
}

.date-range {
    background: rgb(150 150 150 / 40%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding-inline: 20px;
    height: 30px;
}

.datetimegroup h3 {
    color: #fff;
    font-size: 46px;
    line-height: 54px;
    font-family: "frontageregular";
}

.textbottomgroup p {
    color: #000;
    font-weight: 600;
    font-size: 18px;
    margin-top: 15px;
    margin: 0;
}

.datetimegroup {
    margin: 40px 0;
}
.orangegradientmain {
    background: #f57b4f;
    /* background: linear-gradient(149deg, #f57b4f 0, #d94d2e 100%); */
    padding: 30px;
    position: relative;
    border-radius: 20px;
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.orangeimage {
    position: absolute;
    right: 30px;
    top: 30px;
}

.orangeimage img {
    max-width: 230px;
}
.rightInnerWrap {
    /* border: 2px solid #777778; */
    padding: 0 20px 20px 20px;
    max-width: var(--max-width);
    margin: 0 auto;
    transition: 0.3s;
    margin-bottom: 50px;
}
.sec3,
.sec2 {
    transition: 0.3s;
}
.rightInnerWrap .container {
    max-width: 100%;
    padding: 0;
}
/* Kits */
.widgetToolBar {
    background: #2d2d2d;
    border-radius: 8px;
    border: 1px solid #727272;
    position: relative;
}

.widgetToolbarInner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
}

.toolBarRight {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 10px;
}

.toolBarRight > div + div {
    margin-left: 18px;
}

.toolBarLeft h4 {
    color: #fff;
    opacity: 0.5;
    font-size: 14px;
    margin: 0;
    line-height: 20px;
    text-transform: uppercase;
}

.kits {
    margin-top: 30px;
}
.widgetToolBar:before {
    content: "";
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #2d2d2d;
    position: absolute;
    bottom: -10px;
    left: 10px;
    z-index: 99;
}

.widgetToolBar:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #727272;
    position: absolute;
    bottom: -11px;
    left: 10px;
    z-index: 98;
}
.space {
    height: 30px;
}
.colorCircle span {
    display: table;
    width: 27px;
    height: 27px;
    border-radius: 100%;
}
.colorCircle span.white {
    background: #fff;
}
.colorCircle span.blue {
    background: #3478ff;
}
.fontList select {
    border: 1px solid #969696;
    background: #2d2d2d;
    height: 29px;
    padding: 2px 3px;
    font-size: 13px;
}
.widgetuploadinner img {
    width: 100%;
}

.widgetEditBox {
    background: #18191a;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
}

.editTitle {
    color: #fff;
}

.editTitle a.BlueButton {
    margin: 0;
}

.editTitle h3 {
    margin-bottom: 18px;
}

.editTitle p {
    margin-bottom: 28px;
}
.custom-widgetMain {
    display: none;
}
.mainsideBar::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}
/* Kits End */
@media (min-width: 1200px) and (max-width: 1700px) {
    .mainsideBar {
        width: 360px;
    }
    .rightInnerWrap {
        max-width: var(--max-width);
    }
    .rightWrapMain {
        width: var(--width);
        padding-top: 20px;
        overflow-y: auto;
    }
    .themelayoutinnerbox span,
    .BlueButton,
    .customthemelayoutinnerbox span {
        font-size: 14px;
    }
    .banner-title h2 {
        font-size: 30px;
        line-height: 42px;
    }
    h2.maintitle {
        font-size: 28px;
        line-height: 40px;
    }
    .datetimegroup h3 {
        font-size: 34px;
        line-height: 44px;
    }
}

/* 90% */
@media (min-width: 1700px) {
    .rightInnerWrap {
        max-width: var(--max-width) !important;
    }
}
/* 80% */
@media (min-width: 1920px) {
    .rightInnerWrap {
        max-width: var(--max-width) !important;
    }
}
/* 75% */
@media (min-width: 2048px) {
    .rightInnerWrap {
        max-width: var(--max-width) !important;
    }
}

@media (max-width: 700px) {
    .rightInnerWrap {
        padding: 0 !important;
    }
}

.react-resizable-handle .react-resizable-handle-se {
    width: 100px;
    background-color: red;
}

.connectTextarea {
    -webkit-user-select: none;
            user-select: none;
    resize: none;
    overflow-wrap: break-word;
    border-color: transparent;
    background-color: transparent;
    width: 70%;
}

.editText {
    outline: -webkit-focus-ring-color auto 1px;
}

.joinTextarea {
    overflow: hidden;
    -webkit-user-select: none;
            user-select: none;
    max-width: 500px;
    overflow-wrap: break-word;
    border-color: transparent;
    background-color: transparent;
    width: 70%;
}
.ourCodeTextarea {
    width: 90%;
    max-height: 500px;
    background-color: transparent;
    border-color: transparent;
    overflow-wrap: break-word;
    -webkit-user-select: none;
            user-select: none;
    overflow: hidden;
}

/* Custom Widget */
.customWidget {
    display: flex;
    height: 100%;
    background-color: rgb(210, 167, 167);
    /* background: linear-gradient(90deg, #0062ff, #da61ff); */
    padding: 20px;
    overflow: hidden;
}

.input-container {
    position: relative;
}

.aligned-input {
    position: absolute;
}

.aligned-button {
    position: absolute;
}

.topCenter {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    margin: 20px;
}

.bottomCenter {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin: 20px;
}

.topLeft {
    top: 0;
    left: 0;
    margin: 20px;
}

.bottomLeft {
    bottom: 0;
    left: 0;
    margin: 20px;
}

.bottomRight {
    bottom: 0;
    right: 0;
    margin: 20px;
}

.topRight {
    top: 0;
    right: 0;
    margin: 20px;
}
.center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* margin: 20px; */
    /* margin-inline: 20px; */
}

.centerLeft {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    margin-left: 20px;
}

.centerRight {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    margin-right: 20px;
}
.divtext {
    border: ridge 2px;
    padding: 5px;
    width: 10em;
    min-height: 2em;
}
span[contentEditable="true"]:empty:before {
    content: attr(data-placeholder);
    color: #b1a4a4; /* Set placeholder color */
}

.css-o4b71y-MuiAccordionSummary-content {
    width: 100%;
}

.firstCol {
    overflow-y: scroll;
    width: calc((100%) / 3);
}

.firstColRound {
    width: calc((100% - 40px) / 3);
}

.firstCol::-webkit-scrollbar {
    display: none;
}

.secondCol {
    overflow-y: scroll;
    width: calc((100%) / 3);
}
.secondColRound {
    width: calc((100% - 40px) / 3);
}

.secondCol::-webkit-scrollbar {
    display: none;
}
.thirdCol {
    overflow-y: scroll;
    width: calc((100%) / 3);
}
.thirdColRound {
    width: calc((100% - 40px) / 3);
}

.thirdCol::-webkit-scrollbar {
    display: none;
}

.firstRow {
    overflow-y: scroll;
}

.firstRow::-webkit-scrollbar {
    display: none;
}

.secondRow {
    overflow-y: scroll;
}

.secondRow::-webkit-scrollbar {
    display: none;
}
.thirdRow {
    overflow-y: scroll;
}

.thirdRow::-webkit-scrollbar {
    display: none;
}

.header-Icon {
    height: 30px;
    width: 25px;
    max-width: 25px;
}

header.newHeader {
    font-family: "Open Sans", sans-serif;
    color: #fff;
}
header.newHeader {
    position: relative;
    background: #171717;
}

header.newHeader .row {
    display: flex;
    align-items: center;
    justify-content: center;
}
header.newHeader .container-fluid {
    padding: 6px 50px;
}
header.newHeader.blueHeader .cirlenoti {
    border: 2px solid #3478ff;
}

@media (max-width: 767px) {
    header.newHeader .container-fluid {
        padding: 0 24px;
    }
    .newheaderRight {
        width: 80% !important;
        justify-content: flex-end;
        display: none !important;
    }
    .mobileMenuDesign .admin-dashboard-left h3 {
        font-family: "Open Sans", sans-serif;
        color: #fff;
        opacity: 0.5;
        font-size: 16px;
        margin-bottom: 10px;
    }
    .openmobilemenu,
    .closeMenu {
        display: block !important;
    }
    .footer-b-left p {
        padding: 0 20px;
        font-size: 14px;
        text-align: center;
        line-height: 18px;
    }
}

.noti-wrapper {
    margin-top: 30px;
}

@media (max-width: 768px) {
    .header-Logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-block: 10px;
    }
    .mainHeader {
        display: none !important;
    }
    .leftCol {
        padding: 0 !important;
    }
    .header.newHeader .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .modal-Btn {
        /* background-color: #fff; */
        min-width: 100px !important;
    }
    .outer-border {
        width: 30px !important;
        height: 30px !important;
    }
    .go-back {
        justify-content: center !important;
    }
    .sec2Btns {
        justify-content: center !important;
    }
    .float {
        right: 40px !important;
    }
    .header-shortcut-nav {
        display: none !important;
    }

    .column-Widget {
        flex-direction: column !important;
        width: 100% !important;
        row-gap: 20px !important;
    }
    .firstCol {
        width: 100% !important;
        padding-bottom: 50px !important;
    }
    .secondCol {
        width: 100% !important;
    }
    .thirdCol {
        width: 100% !important;
    }
    .annual-budget-heading {
        font-size: 18px;
    }

    .team-right-col {
        width: 100%;
        padding-left: 0 !important;
    }
    .event-detail-cont {
        width: 100%;
    }
    .team-detail {
        row-gap: 10px;
    }
    .event-detail-cont {
        border-bottom-right-radius: 15px !important;
    }
    .eventList {
        padding: 10px !important;
    }
    .notifications-cont {
        height: 70vh !important;
    }
    .noti-wrapper {
        margin-top: unset !important;
    }
    .noti-back {
        margin-block: 20px;
    }
}

.newheaderRight {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.newiconheader {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.newiconheader > div {
    margin-left: 18px;
}
.profileIMg {
    position: relative;
}

@media (max-width: 850px) {
    .mobileMenuDesign .admin-dashboard-left h3 {
        font-family: "Open Sans", sans-serif;
        color: #fff;
        opacity: 0.5;
        font-size: 16px;
        margin-bottom: 10px;
    }
    .admin-dashboard-left {
        width: calc(100% - 30px) !important;
        margin: 0 auto !important;
        background: transparent !important;
        padding: 12px 0 !important;
    }
    .header-menu.newmenuDesign ul li a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .header-menu.newmenuDesign ul li a {
        margin: 0 auto;
        text-align: center;
        padding: 0;
        height: 110px;
        overflow: hidden;
        border-radius: 10px;
    }

    .header-menu.newmenuDesign ul li a img {
        margin: 0 0 9px;
        max-width: 35px;
    }

    .header-menu.newmenuDesign ul li {
        width: 48%;
        margin: 0;
        background: #18191a;
        border-radius: 10px;
        margin-bottom: 4%;
    }

    .header-menu.newmenuDesign ul {
        display: flex;
        flex-direction: initial;
        flex-wrap: wrap;
        padding: 0;
        align-items: center;
        justify-content: start;
    }

    .header-menu.newmenuDesign ul li:nth-child(2n) {
        margin-left: 4%;
    }
    .header-main .header-menu ul {
        display: flex;
        flex-direction: column;
        align-items: self-start;
        padding: 21px 0px;
        width: calc(100% + 30px);
        position: absolute;
        left: -30px;
        background: #18191a;
        top: 45px;
        padding: 22px 10px;
        display: none;
    }

    .header-main .header-menu ul li {
        margin: 0;
    }

    .header-main .header-menu ul li + li {
        margin-top: 12px;
    }
    .redefineText {
        font-size: 34px !important;
    }
    .header-Icon {
        max-width: 100% !important;
    }
    .icons-container {
        padding-block: 4px;
    }
    .header-Logo img {
        height: 34px !important;
    }
}

.mobileMenuDesign {
    position: absolute;
    width: 300px;
    right: -4px;
    top: 100%;
    padding-top: 10px;
    z-index: 999999;
    /* display: none; */
    max-height: 0px;
    transition: max-height 0.5s ease-out;
    overflow: hidden;
    pointer-events: none;
}

.mobileMenuDesign.open {
    max-height: 600px;
    pointer-events: all;
}

.mobileMenuDesign .header-menu.newmenuDesign ul li a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.mobileMenuDesign .header-menu.newmenuDesign ul li a {
    margin: 0 auto;
    text-align: center;
    padding: 0;
    height: 110px;
    overflow: hidden;
    border-radius: 10px;
}

.mobileMenuDesign .header-menu.newmenuDesign ul li a img {
    margin: 0 0 9px;
    max-width: 35px;
}

.mobileMenuDesign .header-menu.newmenuDesign ul li {
    width: 48%;
    margin: 0;
    background: var(--shoutcut-cont-bg);
    border-radius: 10px;
    margin-bottom: 4%;
}

.mobileMenuDesign .header-menu.newmenuDesign ul {
    display: flex;
    flex-direction: initial;
    flex-wrap: wrap;
    padding: 0;
    align-items: center;
    justify-content: start;
}

.mobileMenuDesign .header-menu.newmenuDesign ul li:nth-child(2n) {
    margin-left: 4%;
}
.mobileMenuDesign .admin-dashboard-left {
    width: 100%;
    background: var(--shortcut-menu-bg) !important;
    padding: 20px !important;
    border-radius: 12px;
    position: relative;
    /* box-shadow: var(--event-item-shadow); */
}

.mobileMenuDesign .admin-dashboard-left h3 {
    font-size: 14px;
    margin-bottom: 12px;
    color: var(--sermon-heading);
}

.profileIMg:hover .mobileMenuDesign .admin-dashboard-left:before {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
    content: "";
    position: absolute;
    top: -4px;
    right: 13px;
}

.profileIMg:hover .mobileMenuDesign {
    max-height: 550px;
    pointer-events: all;
    overflow: auto;
    border-radius: 12px;
    box-shadow: var(--event-item-shadow);
}

.mobileMenuDesign::-webkit-scrollbar {
    display: none;
}

.admin-dashboard-left {
    width: 280px;
    background: #0e0e0e;
    padding: 20px 0;
    margin-left: 40px;
    border-radius: 12px;
}
.admin-dashboard-left {
    margin-left: 0px;
    border-radius: 0;
}

.top-menu-inner ul,
.admin-dashboard-left,
.songsList,
.for-box-innner {
    background: #18191a !important;
}

.dropdownnewpro {
    background: var(--shoutcut-cont-bg);
    padding: 12px;
    /* margin-bottom: 20px; */
    border-radius: 8px;
}
.innerdropdownmain {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.innerdropdownmainLEft img {
    width: 35px;
    border-radius: 100%;
    height: 35px;
}

.innerdropdownmainLEft a {
    display: flex;
    align-items: center;
    color: #fff;
}

.innerdropdownmainLEft h5 {
    margin: 0;
    font-size: 15px;
    margin-left: 10px;
}
.angledownopenmenu {
    width: 25px;
    height: 25px;
    background: #2a2b2d;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
}
.angledownopenmenu.activeang i.fa {
    transform: rotate(180deg);
}
.menuDropinner ul {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #2b2b2b;
}

.menuDropinner ul li a {
    color: #fff !important;
    padding: 0;
}
.menuDropinner ul li + li {
    margin-top: 8px;
}
.menuDropinner {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
}

.menuDropinner ul li img,
.menuDropinner ul li i.fa {
    min-width: 21px;
}

.menuDropinner.open {
    max-height: 180px; /* Adjust this value to be greater than the maximum height of your menu */
    pointer-events: all;
}

.header-menu-main-left ul {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.header-menu-main-left ul li + li {
    margin: 0;
    margin-top: 12px;
}

.header-menu-main-left .header-menu {
    justify-content: flex-start;
    width: 100%;
}

.header-menu-main-left ul li a::before {
    display: none;
}

.header-menu-main-left ul li a {
    display: block;
    width: 100%;
    padding: 18px;
    border-radius: 0;
}

.header-menu-main-left ul li {
    width: 100%;
}
header {
    background: #0e0e0e;
}
.header-menu-main-left ul li.active a,
.header-menu-main-left ul li:hover a {
    background: #3478ff;
    color: #fff;
}

.header-menu.newmenuDesign {
    /* padding-top: 14px; */
}

.header-menu ul li + li {
    margin-left: 50px;
}
.header-menu ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.header-menu ul li a {
    color: #6a6a6a;
    font-size: 21px;
    text-decoration: none;
    transition: 0.3s;
}
.header-menu ul li a:hover {
    color: #3478ff;
}
.header-menu ul li {
    margin: 0 0;
}
.header-menu ul li a {
    font-size: 18px !important;
}
.header-menu ul li + li {
    margin-left: 30px;
}

.header-menu.newmenuDesign ul li a {
    font-family: "Open Sans", sans-serif;
    color: #fff;
}

.header-menu.newmenuDesign ul li a img {
    margin-right: 12px;
}

.header-menu.newmenuDesign ul li a span {
    position: relative;
    top: 1px;
}
.openmobilemenu,
.closeMenu {
    display: none !important;
}

/*footer*/
div#footer-sec {
    background: #171717;
}
.fullpage-nav div#footer-sec {
    margin-top: 30px;
}
.has-footer-bottom {
    border-top: 1px solid rgb(255 255 255 / 5%);
}
.footer-bottom .row {
    display: flex;
    align-items: center;
}
.footer-bottom {
    padding: 25px 0;
}
.footer-b-left p {
    color: #fff;
    opacity: 0.4;
    font-size: 18px;
    line-height: 26px;
}
.footer-b-right ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.footer-b-right ul li a i {
    color: #fff;
    font-size: 24px;
    opacity: 0.4;
}
.footer-b-right ul li + li {
    margin-left: 10px;
}

.login-modal {
    background: linear-gradient(70deg, #128dff -0.46%, #be00ee 98.67%);
    border-radius: 20px;
    background-color: transparent;
}

.modal-content {
    background-color: transparent;
    border: unset;
}

.cancel-modal {
    border-radius: 20px;
    background-color: #fff;
}

.welcomText {
    font-size: 34px;
    color: white;
    font-weight: 500;
    line-height: 34px;
}
.redefineText {
    font-size: 44px;
    font-weight: 700;
    color: #fff;
    line-height: 54px;
}
.footerText {
    line-height: 24px;
    font-size: 18px;
    color: #fff;
}

.modal-Btn {
    background-color: transparent;
    border-radius: 50px;
    border: 1px solid #fff;
    align-items: center;
    justify-content: center;
    display: flex;
    /* width: 170px; */
    padding-block: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}

.modal-Btn:hover {
    background-color: #fff;
}

.modal-Btn span {
    color: white;
}

.modal-Btn:hover span {
    color: #2d27fc;
}

.modal-input {
    border-radius: 40px;
    background: rgba(23, 23, 23, 0.05);
    border: none;
    box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.2) inset;
    color: #fff;
    font-size: 14px;
    padding: 18px 20px;
    outline: none;
    width: 100%;
}
input::placeholder {
    /* For modern browsers */
    color: #fff;
}

.forgot-pass {
    color: #fff;
    font-size: 13px;
    margin-top: 10px;
    margin-left: 10px;
    cursor: pointer;
}

.go-back {
    cursor: pointer;
}
.go-back span {
    color: #fff;
}

.outer-border {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    border: 1px solid #fff;
    height: 50px;
    width: 50px;
}
.circleDot {
    height: 13px;
    width: 13px;
    background-color: #fff;
    border-radius: 50px;
}

.outerCircle {
    height: 18px;
    width: 18px;
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
}

.outerCircleHide {
    border: unset !important;
}

.watchSelect {
    background-color: transparent;
    outline: unset;
    border: unset;
    color: #fff;
    padding-block: 4px;
    border-bottom: 1px solid #fff;
}

.gift-type {
    color: #fff;
    font-weight: 600;
}

.react-datepicker__close-icon::after {
    background-color: transparent;
    font-size: 24px;
    font-weight: 600;
}

.react-datepicker__input-container .react-datepicker__calendar-icon {
    top: 7px;
    padding-left: 0 !important;
}
.date-input {
    padding-inline: 30px !important;
}

/* Switch.css */
.switch-container {
    display: inline-block;
}

.switch-checkbox {
    height: 0;
    width: 0;
    visibility: hidden;
    position: absolute;
    transition: 0.4s; /* Smooth background color transition */
}

.switch-label {
    display: block;
    width: 50px;
    height: 25px;
    background: #ececec;
    border-radius: 100px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.4s ease; /* Smooth background color transition */
}

.switch-label .switch-button {
    display: block;
    width: 23px;
    height: 23px;
    background: #fb6262;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 1px;
    transition: transform 0.4s ease 0.1s; /* Smooth transform transition with delay */
}

.switch-checkbox:checked + .switch-label .switch-button {
    transform: translateX(25px);
}

.switch-checkbox:checked + .switch-label {
    background: #ececec;
}

/* Swich Rules */

@media (max-width: 768px) {
    .togSwichCls {
        justify-content: flex-start !important;
    }
}

.togSwichCls .switch input {
    display: none;
}
.togSwichCls .switch {
    display: inline-block;
    width: 55px;
    height: 26px;
    transform: translateY(14%);
    position: relative;
}
/* Style Wired */
.togSwichCls .slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 30px;
    cursor: pointer;
    overflow: hidden;
    transition: 0.4s;
    background-color: #ececec;
    border: 1px solid #fbfbfb;
}
.togSwichCls .slider:before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background: #8b8b8b;
    border-radius: 30px;
    transform: translateX(2px);
    transition: 0.4s;
    width: 22px;
    height: 22px;
    margin-top: 1px;
}

.togSwichCls input:checked + .slider:before {
    transform: translateX(30px);
    background: #fb6262;
}

@media (max-width: 400px) {
    .togSwichCls input:checked + .slider:before {
        transform: translateX(25px) !important;
    }
}

/* video {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 20px;
}
.video-react.video-react-fluid {
  height: 100% !important;
}
.video-react {
  position: unset !important;
  display: contents !important;
} */

video {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 20px;
}
.video-react {
    position: unset !important;
    display: contents !important;
}
.video-react.video-react-fluid {
    padding-top: 56.25% !important;
    height: 100% !important;
}

.float {
    position: fixed;
    right: 170px;
    bottom: 40px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 6px;
    cursor: pointer;
}

.login-caution {
    background-color: #0f101d;
    padding: 12px 20px;
    border-radius: 9px;
}

.login-caution:after {
    content: "";
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid #0f101d;
    right: -12px;
    position: absolute;
    top: 10px;
}

.header-Logo {
    display: none;
}

.live-gif {
    position: absolute;
    width: 100px;
    height: 50px;
    top: 0;
    right: 130px;
    z-index: 1;
}

@media (max-width: 768px) {
    .header-Logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-block: 10px;
    }
    .mainHeader {
        display: none !important;
    }
    .leftCol {
        padding: 0 !important;
    }
    .header.newHeader .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .live-gif {
        right: 50px !important;
        /* width: 80px !important; */
    }
    .logout-mian-header {
        padding-inline: 0rem !important;
    }
}

@media (max-width: 465px) {
    .live-gif {
        right: 30px !important;
        width: 80px !important;
    }
    .outline-Text {
        font-size: 34px !important;
    }
    .contentcenter h3 {
        font-size: 20px !important;
    }
}

.graph-select {
    border-radius: 5px;
    background-color: transparent;
    color: #fff;
    border-color: #fff;
    position: absolute;
    right: 60px;
    border: 1px solid #fff;
    outline: unset;
    padding-block: 4px;
}

@media (max-width: 560px) {
    .graph-select {
        right: 20px !important;
        top: 10px !important;
        padding: 0;
        font-size: 14px;
    }
    .echarts-for-react {
        zoom: 80% !important;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .live-gif {
        right: 60px !important;
        width: 80px !important;
    }
}

@media (max-width: 450px) {
    .live-gif {
        right: 20px !important;
        width: 65px !important;
        height: 30px !important;
    }
}

/* Customize the scrollbar width */
.chat-Section::-webkit-scrollbar {
    /* display: none; */
    width: 3px; /* Width of the entire scrollbar */
    height: 3px;
}
/* Customize the track (the background of the scrollbar) */
.chat-Section::-webkit-scrollbar-track {
    background: transparent; /* Color of the track */
}
/* Customize the thumb (the draggable part of the scrollbar) */
.chat-Section::-webkit-scrollbar-thumb {
    background: #696767; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
/* Customize the thumb when hovered */
.chat-Section::-webkit-scrollbar-thumb:hover {
    background: #555; /* Color of the thumb on hover */
}

.chat-Section {
    padding: 6px;
}

.input-container {
    border: 2px solid rgb(100, 160, 240); /* Initial border color */
    border-radius: 10px;
    box-shadow: 0 0 1px rgb(100, 175, 240), 0 0 5px rgb(100, 160, 240),
        0 0 1px rgb(100, 160, 240), 1px 0 1px rgb(100, 160, 240),
        0 0 1px rgb(100, 160, 240), 0 0 1px rgb(100, 160, 240),
        0 0 5px rgb(100, 160, 240);
}

.broadcast {
    height: 25px;
    width: 25px;
    transform: rotate(-30deg);
}

.sermon-Cont,
.mobile-sermon-Cont {
    background-color: var(--widget-bg);
    height: 100%;
    padding: 10px;
    overflow: hidden;
    justify-content: space-between;
    column-gap: 4px;
    border-radius: 20px;
}

.sermon-section {
    row-gap: 10px;
    margin-top: 6px;
    overflow: auto;
    height: 100%;
}

.sermon-section::-webkit-scrollbar {
    display: none;
}

.sermon-series-section {
    row-gap: 10px;
    margin-top: 6px;
    overflow: auto;
    height: 100%;
}

.sermon-series-section::-webkit-scrollbar {
    display: none;
}

.sermon-heading {
    color: var(--sermon-heading);
    font-size: 16px;
    font-weight: bold;
    margin: 0;
}

@media (max-width: 1000px) {
    .sermon-series-wrapper {
        width: 49%;
    }
    .sermon-wrapper {
        width: 49%;
    }
}

@media (max-width: 800px) {
    .sermon-Cont {
        flex-direction: column !important;
        overflow: auto !important;
        height: -webkit-fill-available !important;
    }
    .mobile-sermon-Cont {
        zoom: 90%;
    }
    .sermon-series-wrapper {
        width: 100% !important;
    }
    .sermon-wrapper {
        width: 100% !important;
    }
    .sermon-series-section {
        height: 200px !important;
    }
    .sermon-section {
        height: 200px !important;
    }
}

.header-heading {
    cursor: pointer;
    color: var(--sermon-heading);
}

.logout-mian-header {
    padding-inline: 3rem;
}

.admin-dashboard-left ul li {
    margin-bottom: 10px;
    color: var(--sermon-heading);
}

.topPart {
    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.giveButton {
    background-color: #fff;
    padding: 10px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 6px;
    width: 40%;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Hide increment and decrement buttons in Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

/* .rs-progress-line-outer {
  height: 140px !important;
} */

.rs-progress.rs-progress-line.rs-progress-line-vertical {
    height: 100%;
}

.giving {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border-radius: 15px;
    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);
    height: 100%;
    padding: 20px;
}

.givingInput {
    color: #ffffff;
    background-color: transparent;
    outline: unset;
    border: unset;
}
.givingInput::placeholder {
    color: #ffffff;
}
.givingInput2 {
    color: #ffffff;
    background-color: transparent;
    outline: unset;
    border: unset;
}

.givingInput2::placeholder {
    color: grey;
}

.goalInput {
    color: #ffffff;
    background-color: transparent;
    outline: unset;
    border: unset;
}
.goalInput::placeholder {
    color: grey;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
}

.toggle-switch input {
    display: none;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 34px;
    transition: 0.4s;
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: grey;
    border-radius: 50%;
    transition: 0.4s;
}
input:checked + .toggle-slider {
    /* background-color: #2196F3; */
}

input:checked + .toggle-slider:before {
    transform: translateX(26px);
    background-color: #fa7373;
}

.system-toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 34px;
    transition: 0.4s;
    width: 45px;
}

.system-toggle-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: grey;
    border-radius: 50%;
    transition: 0.4s;
}

input:checked + .system-toggle-slider:before {
    transform: translateX(20px);
    background-color: #3478ff;
}

.givingGoal {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 20px;
    overflow: auto;
}

.givingGoal::-webkit-scrollbar {
    display: none;
}

.give-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: calc(100vh - 86px);
    margin-top: 50px;
    padding-bottom: 20px;
    width: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.give-banner.group-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.give-banner.serve-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.give-banner.kids-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.give-banner.about-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    margin-top: 0 !important;
}

.parent-div {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* Four equal columns */
    gap: 10px; /* Gap between the grid items */
    margin: 10px; /* Optional: Margin around the grid */
    width: 95%;
    overflow: auto;
    padding-inline: 4px;
}

.parent-div::-webkit-scrollbar {
    width: 0.1em !important;
    /* display: none; */
}

.parent-div::-webkit-scrollbar {
    width: 2px; /* Width of the entire scrollbar */
    background: transparent;
    border-radius: 10px;
}
/* Customize the track (the background of the scrollbar) */
.parent-div::-webkit-scrollbar-track {
    background: "#fff"; /* Color of the track */
}
/* Customize the thumb (the draggable part of the scrollbar) */
.parent-div::-webkit-scrollbar-thumb {
    background: #000; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
/* Customize the thumb when hovered */
.parent-div::-webkit-scrollbar-thumb:hover {
    background: #000; /* Color of the thumb on hover */
}

.child-div {
    padding: 20px;
    text-align: center;
}

.padding-zero{
    padding: 0 !important;
}

@media (max-width: 1000px) {
    .parent-div {
        display: flex;
        flex-wrap: wrap; /* Enable wrapping on smaller screens */
    }

    .child-div {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 20px); /* Make each div take 50% width minus gap */
    }
}

@media (max-width: 480px) {
    .child-div {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(100% - 20px); /* Make each div take full width minus gap */
    }
}
.outline-Text {
    -webkit-text-stroke: 2px #fa7373;
    -webkit-text-fill-color: transparent;

    /* fallback */
    color: #fb6d6d;
    font-family: "Roboto", sans-serif;
    /* text-align: center; */
    font-size: 54px;
}

.inputCont {
    border-bottom: 1px solid #fff;
    justify-content: space-between;
}

.react-datepicker__input-container input {
    width: 98% !important;
    background-color: transparent;
    font-size: 12px;
    color: #fff;
    outline: unset;
    border: unset;
}

.react-datepicker-popper .react-datepicker__triangle {
    display: none;
}
.react-datepicker {
    left: 30%;
}

.ach-card-cont {
    min-height: 86px;
}

@media screen and (max-width: 1440px) {
    .paymentMethods {
        height: 220px !important;
    }
    .payment-method-cont,
    .ach-card-cont {
        min-height: 86px !important;
    }
}

@media screen and (max-width: 460px) {
    .paymentMethods {
        height: 120px !important;
    }
}

.paymentMethods {
    height: 200px;
    overflow-y: scroll;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-inline: 4px;
    padding-block: 10px;
}
.paymentMethods::-webkit-scrollbar {
    width: 0.2em !important;
    /* display: none; */
}

.paymentMethods::-webkit-scrollbar {
    width: 4px; /* Width of the entire scrollbar */
    background: #000;
    border-radius: 10px;
}
/* Customize the track (the background of the scrollbar) */
.paymentMethods::-webkit-scrollbar-track {
    background: "#fff"; /* Color of the track */
}
/* Customize the thumb (the draggable part of the scrollbar) */
.paymentMethods::-webkit-scrollbar-thumb {
    background: #fff; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
/* Customize the thumb when hovered */
.paymentMethods::-webkit-scrollbar-thumb:hover {
    background: #fff; /* Color of the thumb on hover */
}

.parent {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* Four equal columns */
    gap: 10px; /* Gap between the grid items */
    width: 100%;
    overflow: auto;
}

.child {
    padding: 10px;
    /* text-align: center; */
}

@media (max-width: 1000px) {
    .parent {
        display: flex;
        flex-wrap: wrap; /* Enable wrapping on smaller screens */
    }

    .child {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 20px); /* Make each div take 50% width minus gap */
    }
}

@media (max-width: 480px) {
    .child {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(100% - 20px); /* Make each div take full width minus gap */
    }
}

.reoccuringGifts {
    height: 120px;
    overflow-y: auto;
    row-gap: 4px;
    padding-inline: 4px;
}
.reoccuringGifts::-webkit-scrollbar {
    width: 0.2em !important;
}

.reoccuringGifts::-webkit-scrollbar {
    width: 4px; /* Width of the entire scrollbar */
    background: #000;
    border-radius: 10px;
}
/* Customize the track (the background of the scrollbar) */
.reoccuringGifts::-webkit-scrollbar-track {
    background: "#fff"; /* Color of the track */
}
/* Customize the thumb (the draggable part of the scrollbar) */
.reoccuringGifts::-webkit-scrollbar-thumb {
    background: #fff; /* Color of the thumb */
    border-radius: 10px; /* Rounded corners */
}
/* Customize the thumb when hovered */
.reoccuringGifts::-webkit-scrollbar-thumb:hover {
    background: #fff; /* Color of the thumb on hover */
}

.subscriptionItem {
    background: linear-gradient(120deg, #d4d0d0 0, #ffd5d3 100%);
    border-radius: 6px;
    padding: 14px;
}

.react-datepicker-wrapper {
    width: 90% !important;
}

.confirmation-dialog {
    box-shadow: 2px 2px 2px 2px rgb(84 75 75 / 50%);
}

.groupList {
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: cover;
    background-repeat: no-repeat;
    overflow: auto;
}

.groupList::-webkit-scrollbar {
    width: 2px;
}

.teamList {
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-size: cover;
    background-repeat: no-repeat;
}

.songs-list {
    display: flex;
    height: 100%;
    background-color: #fff;
    flex-direction: column;
    padding: 20px;
    overflow: hidden;
    box-shadow: var(--noti-cont-shadow);
}

.team-member {
    display: flex;
    padding: 20px;
    height: 100%;
    /* background-color: #171717; */
    background-color: var(--widget-bg);
    align-items: center;
    justify-content: center;
    box-shadow: var(--noti-cont-shadow);
}

.profile-name {
    text-align: center;
    color: var(--sermon-heading);
    font-size: 18px;
    margin-top: 16px;
    font-weight: 500;
    font-family: sans-serif;
    text-transform: capitalize;
    cursor: pointer;
}

.profile-name:hover {
    text-decoration-line: underline;
    text-decoration-color: #007bff;
}

.profile-icon {
    height: 60px;
    width: 60px;
    object-fit: contain;
}

.calendar {
    height: 100%;
    overflow: hidden;
    box-shadow: var(--noti-cont-shadow);
}

.team-detail {
    height: 100%;
    overflow: scroll;
    box-shadow: var(--noti-cont-shadow);
}

.team-detail::-webkit-scrollbar {
    display: none;
}

.title-text {
    font-size: 18px;
    margin: 0px;
    color: var(--sermon-heading) !important;
    font-family: sans-serif;
}

.sub-text {
    font-family: sans-serif;
    font-size: 14px;
    margin: 0px;
    color: #a5a5a5 !important;
}

.team-right-col::-webkit-scrollbar {
    display: none;
}

.imageInnerText h4 {
    margin: 0px;
    font-size: 13px;
    line-height: 20px;
    font-family: sans-serif;
    font-weight: 600;
}

.imageInnerText {
    position: absolute;
    bottom: 0px;
    color: #fff;
    padding: 15px;
    background: rgb(0 0 0 / 44%);
    width: 100%;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

.selected-event {
    border-radius: 15px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    cursor: pointer;
}

.unselected-event {
    border-radius: 15px;
    cursor: pointer;
}

/* .selected-event:before {
    content: "";
    position: absolute;
    z-index: 99999;
    background: url(../../assets/images/bar.png) no-repeat;
    left: -10px;
    top: -14px;
    width: 15px;
    height: 268px;
    border-radius: 0;
    background-size: cover;
    background-position: center left;
    filter: brightness(0);
} */

.selected-event {
    position: relative;
}

.selected-event:before {
    content: "";
    position: absolute;
    z-index: 1;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
    left: -10px;
    top: -14px;
    width: 15px;
    height: 268px;
    border-radius: 0;
    background-size: cover;
    background-position: center left;
}

.selected-event:after {
    content: "";
    position: absolute;
    z-index: 2;
    left: -10px;
    top: -14px;
    width: 15px;
    height: 268px;
    background-color: var(--selected-event);
    mix-blend-mode: screen;
}

.songs-cont::-webkit-scrollbar {
    display: none;
}

.accept-btn {
    background-color: #28a830;
    border-radius: 3px;
    padding: 6px;
    color: #fff;
    font-size: 14px;
}

.decline-btn {
    background-color: #ff3434;
    border-radius: 3px;
    padding: 6px;
    color: #fff;
    font-size: 14px;
}

.song-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out,
        padding-top 0.3s ease-in-out;
    opacity: 0;
    padding-top: 0;
}

.song-content.open {
    opacity: 1;
    padding-top: 10px;
}

.song-info-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out,
        padding 0.3s ease-in-out;
    opacity: 0;
    padding-top: 0;
}

.song-info-content.open {
    opacity: 1;
    padding: 20px;
    max-height: 500px;
}

.additional-data {
    color: #000;
    min-width: 30%;
}

.track-cont {
    overflow: auto;
}

.track-cont::-webkit-scrollbar {
    display: none;
}

/* .slider {
  border-radius: 0 !important;
} */

.team-blur-footer {
    position: absolute;
    bottom: 0px;
    padding: 18px;
    padding-left: 30px;
    left: 0px;
    width: 100%;
    background: rgba(37, 37, 37, 0.6);
    backdrop-filter: blur(7.5px);
    align-items: flex-start;
}

.event-detail-cont {
    flex-direction: column;
    /* background-color: #171717; */
    background-color: var(--widget-bg);
    border-radius: 15px;
    padding: 15px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.event-detail-cont div img {
    object-fit: cover;
    height: 200px;
    width: 100%;
    border-radius: 10px;
}

.event-img {
    border-radius: 10px;
    height: 220px;
    width: 100%;
    object-fit: cover;
}

.event-name {
    color: var(--sermon-heading);
    font-weight: bold;
    margin: 0;
    margin-bottom: 4px;
}

.event-item-cont {
    background-color: var(--widget-bg);
    min-height: 240px;
    position: relative;
    padding: 10px;
    box-shadow: var(--event-item-shadow);
}

.song-cont {
    background-color: var(--song-cont-bg);
    padding-block: 15px;
    padding-left: 20px;
    align-items: center;
    cursor: pointer;
}
.song-cont span {
    color: var(--sermon-heading) !important;
    font-size: 16px;
    font-family: sans-serif;
    margin-inline: 30px;
}

.carousel-root {
    width: 100%;
}

.option-parent {
    overflow-x: scroll;
    height: 100%;
    justify-content: space-between;
}

.option-parent::-webkit-scrollbar {
    display: none;
}

.option-cont {
    background-color: #464748;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 180px;
    padding: 16px;
    cursor: pointer;
}
.option-cont.selected {
    background-color: #fff;
}

.option-cont span {
    color: #bababa;
    font-size: 16px;
}

.option-cont.selected span {
    color: #000;
}

.arrangement-option {
    background-color: #000;
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 10px;
    border-radius: 10px;
    min-height: 35px;
    min-width: 150px;
}

.arrangement-option h6 {
    color: #fff;
}

.youtube-cont {
    background: red;
    border-radius: 7px;
    text-align: center;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    max-width: 100px;
}

.youtube-cont h6 {
    color: #fff;
    font-size: 14px;
}

.serve-block {
    background-color: #f57b4f;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    padding-block: 60px;
    margin-bottom: 60px;
    row-gap: 50px;
}

.about-us {
    padding: 20px;
    width: 90%;
    justify-content: space-between;
    padding-block: 80px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

@media (max-width: 768px) {
    .about-us {
        grid-template-columns: repeat(2, 1fr);
    }
    .grid-images {
        grid-template-columns: repeat(1, 1fr) !important;
    }
}

@media (max-width: 480px) {
    .about-us {
        grid-template-columns: 1fr;
    }
    .leadership-img {
        height: 300px !important;
        /* background-position: center; */
        background-size: cover !important;
    }
    .serve-block p {
        font-size: 12px !important;
        line-height: 14px !important;
    }
    .serve-block h3 {
        font-size: 20px !important;
        line-height: 20px !important;
    }
    .give-banner {
        height: 300px !important;
    }
    .give-banner h1 {
        font-size: 24px !important;
    }
    .leadership-img p {
        font-size: 10px !important;
    }
    .budget-resource-h3 {
        font-size: 18px !important;
        line-height: 1.3 !important;
    }
}

.our-leadership {
    display: flex;
    flex-direction: column;
    width: 90%;
    padding-block: 30px;
    padding-inline: 20px;
    font-family: sans-serif;
}

.leadership-img {
    border-radius: 20px;
    height: 600px;
    align-items: center;
    justify-content: flex-end;
    display: flex;
    /* background-position: center; */
    background-size: cover;
    flex-direction: column;
}

.grid-images {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 40px;
}

.leadership-img h2,
.leadership-img p {
    background-color: rgba(255, 255, 255, 0.5);
    color: #000;
    font-family: sans-serif;
    font-weight: 600;
    text-align: center;
    padding-inline: 4px;
    line-height: unset;
    margin-inline: 10px;
    border-radius: 2px;
}

.leadership-img h2 {
    font-size: 22px;
    margin-bottom: 30px;
}

.leadership-img p {
    font-size: 14px;
    padding: 8px;
    border-radius: 10px;
    text-align: justify;
}

.header-shortcut-nav a:hover {
    text-decoration-line: underline !important;
    text-decoration-color: #fff !important;
}

.bottom-border {
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}

.budget-resource-h3 {
    color: #fa7373;
    font-weight: bold;
    margin: 0;
}

.fc.fc-media-screen.fc-direction-ltr.fc-theme-standard {
    height: 100%;
    background-color: var(--widget-bg);
}

.fc .fc-toolbar.fc-header-toolbar {
    padding: 10px 10px 0 10px;
}

.fc .fc-daygrid-day-top {
    flex-direction: row !important;
}

.fc-daygrid-event {
    border-radius: 0;
}

.day-number {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    border-radius: 50px;
    height: 24px;
    width: 24px;
}

.day-number h5 {
    color: var(--sermon-heading);
    cursor: pointer;
    font-size: 14px;
}

.fc .fc-daygrid-day-number {
    text-decoration: none;
}

.fc .fc-col-header-cell-cushion {
    color: grey;
}

.fc-h-event .fc-event-title-container {
    text-align: center;
}

.fc-theme-standard th {
    border: unset;
    border-bottom: 1px solid #2d2d2d !important;
}

.fc-scroller {
    overflow: auto !important;
}
.fc-scroller::-webkit-scrollbar {
    display: none !important;
}

.fc .fc-scroller-liquid-absolute {
    overflow: auto !important;
}

.fc .fc-scroller-liquid-absolute::-webkit-scrollbar {
    width: 0.1em !important;
    background-color: transparent !important;
    height: 0.1em !important;
}

.fc .fc-scroller-liquid-absolute::-webkit-scrollbar-thumb {
    width: 0.1em !important;
    background-color: rgba(43, 43, 43, 0) !important;
}

.fc .fc-scroller-liquid-absolute::-webkit-scrollbar-track {
    background-color: transparent !important;
}

.fc-theme-standard .fc-scrollgrid {
    border: unset !important;
    border-width: 0px !important;
}

.fc .fc-button-primary {
    background-color: var(--fc-button-primary);
    text-transform: capitalize;
}

.fc .fc-button-primary:disabled {
    background-color: var(--fc-button-primary-dis);
    opacity: 0.4;
}

.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child),
.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {
    border: unset !important;
    box-shadow: none;
}

.fc-theme-standard td {
    border: 1px solid #2d2d2d;
}

.fc-scrollgrid-sync-inner {
    text-align: left;
}

.fc-popover {
    background-color: #131516 !important;
}

@media (max-width: 468px) {
    .fc-popover {
        top: unset !important;
        left: unset !important;
        transform: translate(20%, 20%);
    }
    .group-list-title {
        font-size: 22px !important;
        line-height: 1.2 !important;
    }
    .group-list-desp {
        font-size: 12px !important;
        line-height: 1.2 !important;
    }
}

@media (max-width: 350px) {
    .fc-popover {
        transform: translate(10%, 10%);
    }
}

.fc-theme-standard .fc-list {
    border: unset !important;
}

:root {
    --fc-list-event-hover-bg-color: #42424233 !important;
}

.fc .fc-list-empty {
    background-color: #5c55554d;
}

.fc-theme-standard .fc-list-day-cushion {
    background-color: hsl(0deg 0% 18.43%);
}

.fc-more-popover-misc {
    display: none;
}

.logout-giving-cont {
    overflow: scroll;
    height: 100%;
    justify-content: space-between;
}

.logout-giving-cont::-webkit-scrollbar {
    display: none !important;
}

.inputs-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

@media (max-width: 768px) {
    .inputs-wrapper {
        grid-template-columns: 1fr; /* On smaller devices, single column */
    }
}

.single-widget-cont::-webkit-scrollbar {
    width: 0.5rem !important;
}

.notes-cont::-webkit-scrollbar {
    width: 0.5rem !important;
}

.video-chat-cont::-webkit-scrollbar {
    width: 0.5 !important;
}

@media (max-width: 768px) {
    .fc-button-group {
        flex-wrap: wrap !important;
    }
    .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
        flex-wrap: wrap !important;
        zoom: 80% !important;
    }
}

.text-span::-webkit-scrollbar {
    width: 2px !important;
}

.chat-wrapper {
    height: 100vh;
    display: flex;
    overflow: hidden;
    width: 100%;
}

.conversation-sidebar {
    transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
    width: 320px;
    overflow: hidden;
    left: 0;
    height: 90vh;
    background-color: white;
}

.convo-cont::-webkit-scrollbar {
    width: 2px;
}

.messages-wrapper::-webkit-scrollbar {
    width: 2px;
}

.message-cont::-webkit-scrollbar {
    width: 2px;
}

.convo-item {
    cursor: pointer;
    border-bottom: 1px solid #4f4c4c;
    align-items: center;
    display: flex;
}

.notifications-cont {
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding-right: 4px;
    height: 75vh;
}

.notifications-cont::-webkit-scrollbar {
    width: 4px;
}
.notifications-cont::-webkit-scrollbar-thumb {
    width: 4px;
    background-color: gray;
    border-radius: 10px;
}

.notification-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    border-radius: 10px;
    width: 320px;
    max-height: 70vh;
    background-color: var(--notification-menu);
    padding: 20px;
    right: -40px;
    top: 40px;
    box-shadow: var(--noti-cont-shadow);
}
.noti-profile-img {
    height: 56px;
    width: 56px;
    object-fit: cover;
    border-radius: 100px;
}

.noti-icon-img {
    height: 28px;
    width: 28px;
    object-fit: contain;
    border-radius: 100px;
    position: absolute;
    bottom: -2px;
    right: -10px;
}

.all-read-ellipsis {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border-radius: 100px;
}
.all-read-ellipsis:hover {
    background-color: #3c3c3c;
    cursor: pointer;
}
/* .noti-item:hover {
    background-color: #353535 !important;
    cursor: pointer;
} */

.chat-head-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 50px;
    width: 50px;
    background-color: var(--chat-head-bg);
    border-radius: 10px;
    box-shadow: var(--noti-cont-shadow);
}

.chat-head-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: fixed;
    bottom: 10px;
    right: 25px;
    z-index: 1;

    /* overflow: auto; */
    /* width: calc(100vw - 80px); */
}

.chat-head-wrapper::-webkit-scrollbar {
    height: 4px;
}

.chat-head-wrapper::-webkit-scrollbar-track {
    background: transparent !important;
}

.chat-head-wrapper::-webkit-scrollbar-thumb {
    background: #414040; /* Color of the thumb */
    border-radius: 10px;
}

@media (max-width: 468px) {
    .chat-head-wrapper {
        display: none !important;
    }
}

.chat-head-seacrh::-webkit-input-placeholder {
    color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;IACrC,oBAAoB;IACpB,uBAAuB;IACvB,2CAA2C;IAC3C,yCAAyC;IACzC,wBAAwB;IACxB,2BAA2B;IAC3B,qCAAqC;IACrC,yCAAyC;AAC7C;AACA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,2CAA2C;IAC3C,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI;iBACa;IACb,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,cAAc;IACd,8BAA8B;IAC9B,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;AACA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,aAAa;AACjB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,yBAAyB,EAAE,yCAAyC;AACxE;AACA;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB,EAAE,uBAAuB;AACpD;AACA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB,EAAE,oBAAoB;AAC7C;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yDAA4D;IAC5D,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA4D;IAC5D,sBAAsB;AAC1B;;AAEA,oCAAoC;AACpC;;;IAGI;;AAEJ;IACI,6DAA6D;IAC7D,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,oBAAoB;IACxB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,cAAc;IAClB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;IACA;QACI,wBAAwB;QACxB,SAAS;IACb;IACA;;QAEI,SAAS;IACb;IACA;QACI,sBAAsB;IAC1B;IACA;;QAEI,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;IACA;;QAEI,2BAA2B;QAC3B,uBAAuB;QACvB,6BAA6B;IACjC;IACA;;QAEI,wBAAwB;IAC5B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,kCAAkC;AAClC;IACI,UAAU,EAAE,kCAAkC;AAClD;AACA,0DAA0D;AAC1D;IACI,uBAAuB,EAAE,uBAAuB;AACpD;AACA,8DAA8D;AAC9D;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB,EAAE,oBAAoB;AAC7C;AACA,qCAAqC;AACrC;IACI,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA,kCAAkC;AAClC;IACI,UAAU,EAAE,kCAAkC;AAClD;AACA,0DAA0D;AAC1D;IACI,uBAAuB,EAAE,uBAAuB;AACpD;AACA,8DAA8D;AAC9D;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB,EAAE,oBAAoB;AAC7C;AACA,qCAAqC;AACrC;IACI,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;AAOA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,kEAAkE;IAClE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,4BAA4B;IAC5B,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,4DAA4D;IAC5D,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,kEAAkE;IAClE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iEAAiE;IACjE,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,2DAA2D;IAC3D,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;AAChC;AACA;;;GAGG;;AAEH;IACI,mBAAmB;IACnB,kEAAkE;IAClE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kEAAkE;IAClE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,kEAAkE;IAClE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,UAAU;AACd;AACA,SAAS;AACT;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,uBAAuB;IACvB,aAAa;AACjB;AACA,aAAa;AACb;IACI;QACI,YAAY;IAChB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;IACA;;;QAGI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,QAAQ;AACR;IACI;QACI,sCAAsC;IAC1C;AACJ;AACA,QAAQ;AACR;IACI;QACI,sCAAsC;IAC1C;AACJ;AACA,QAAQ;AACR;IACI;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,UAAU;AACd;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,0DAA0D;IAC1D,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,YAAY;AAChB;AACA;IACI,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,cAAc,EAAE,0BAA0B;AAC9C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,wBAAwB;IAC5B;IACA;QACI,oCAAoC;QACpC,WAAW;QACX,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;IACA;;QAEI,yBAAyB;IAC7B;IACA;QACI,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;IACA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,kCAAkC;IACtC;IACA;QACI,kCAAkC;IACtC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iCAAiC;QACjC,sBAAsB;QACtB,wBAAwB;IAC5B;IACA;QACI,sBAAsB;QACtB,+BAA+B;IACnC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,oCAAoC;QACpC,WAAW;QACX,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,kCAAkC;QAClC,0BAA0B;IAC9B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,UAAU;QACV,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,SAAS;QACT,mBAAmB;QACnB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,UAAU;QACV,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,iBAAiB;QACjB,wBAAwB;QACxB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,SAAS;QACT,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,8CAA8C;IAC9C,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;;IAII,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,iBAAiB,EAAE,yEAAyE;IAC5F,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;AACA;;IAEI,wBAAwB;AAC5B;;AAEA,SAAS;AACT;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kEAAkE;IAClE,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,qEAAqE;AACzE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,qDAAqD;IACrD,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,0BAA0B;AAC9B;AACA;IACI,+BAA+B;AACnC;;AAEA,eAAe;AACf;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB,EAAE,uCAAuC;AAC7D;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,sCAAsC,EAAE,uCAAuC;AACnF;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,2CAA2C;AACrF;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;;AAEhB;IACI;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;AACtB;AACA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,sCAAsC;IAC1C;AACJ;;AAEA;;;;;;;;;;;;GAYG;;AAEH;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;AACA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,sBAAsB;QACtB,4BAA4B;IAChC;IACA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,UAAU;QACV,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA,kCAAkC;AAClC;IACI,mBAAmB;IACnB,UAAU,EAAE,kCAAkC;IAC9C,WAAW;AACf;AACA,0DAA0D;AAC1D;IACI,uBAAuB,EAAE,uBAAuB;AACpD;AACA,8DAA8D;AAC9D;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB,EAAE,oBAAoB;AAC7C;AACA,qCAAqC;AACrC;IACI,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC,EAAE,yBAAyB;IAC/D,mBAAmB;IACnB;;;kCAG8B;AAClC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,yBAAyB;QACzB,yCAAyC;IAC7C;IACA;QACI,SAAS;IACb;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,2DAA2D;IAC3D,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,oDAAoD;AACpD;IACI,0BAA0B;AAC9B;;AAEA;;GAEG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,2DAA2D;IAC3D,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,cAAc;IACd,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,6BAA6B;IAC7B,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,cAAc;IACd,aAAa;AACjB;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yDAA8D;IAC9D,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,yDAAoE;AACxE;;AAEA;IACI,yDAAoD;AACxD;AACA;IACI,yDAA+D;AACnE;AACA;IACI,yDAAuD;IACvD,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,SAAS,EAAE,+BAA+B;IAC1C,YAAY,EAAE,qCAAqC;IACnD,UAAU;IACV,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU,EAAE,kCAAkC;IAC9C,uBAAuB;IACvB,mBAAmB;AACvB;AACA,0DAA0D;AAC1D;IACI,kBAAkB,EAAE,uBAAuB;AAC/C;AACA,8DAA8D;AAC9D;IACI,gBAAgB,EAAE,uBAAuB;IACzC,mBAAmB,EAAE,oBAAoB;AAC7C;AACA,qCAAqC;AACrC;IACI,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;QACb,eAAe,EAAE,uCAAuC;IAC5D;;IAEA;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B,EAAE,2CAA2C;IAC3E;AACJ;;AAEA;IACI;QACI,YAA2B;QAA3B,cAA2B;QAA3B,6BAA2B,EAAE,4CAA4C;IAC7E;AACJ;AACA;IACI,gCAAgC;IAChC,oCAAoC;;IAEpC,aAAa;IACb,cAAc;IACd,iCAAiC;IACjC,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;;QAEI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU,EAAE,kCAAkC;IAC9C,gBAAgB;IAChB,mBAAmB;AACvB;AACA,0DAA0D;AAC1D;IACI,kBAAkB,EAAE,uBAAuB;AAC/C;AACA,8DAA8D;AAC9D;IACI,gBAAgB,EAAE,uBAAuB;IACzC,mBAAmB,EAAE,oBAAoB;AAC7C;AACA,qCAAqC;AACrC;IACI,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,SAAS,EAAE,+BAA+B;IAC1C,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;QACb,eAAe,EAAE,uCAAuC;IAC5D;;IAEA;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B,EAAE,2CAA2C;IAC3E;AACJ;;AAEA;IACI;QACI,YAA2B;QAA3B,cAA2B;QAA3B,6BAA2B,EAAE,4CAA4C;IAC7E;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU,EAAE,kCAAkC;IAC9C,gBAAgB;IAChB,mBAAmB;AACvB;AACA,0DAA0D;AAC1D;IACI,kBAAkB,EAAE,uBAAuB;AAC/C;AACA,8DAA8D;AAC9D;IACI,gBAAgB,EAAE,uBAAuB;IACzC,mBAAmB,EAAE,oBAAoB;AAC7C;AACA,qCAAqC;AACrC;IACI,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,yDAA2D;IAC3D,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,yDAAmD;IACnD,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,+BAA+B;IAC/B,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,WAAW;IACX,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,6DAAsD;IACtD,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;oCACgC;IAChC,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;gCAC4B;IAC5B,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,uCAAuC;IACvC,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;QACxB,iCAAiC;QACjC,iCAAiC;IACrC;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,iCAAiC;IACjC,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,0CAA0C;IAC1C,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;;IAEI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,qBAAqB;QACrB,sBAAsB;QACtB,8BAA8B;IAClC;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B,EAAE,sCAAsC;IACtE;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,8DAA8D;IAC9D,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,aAAa;IACb,YAAY;IACZ,SAAS;IACT,mCAAmC;AACvC;AACA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;AACA;;;GAGG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,qCAAqC;IACrC,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,UAAU;;IAEV,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,WAAW;AACf","sourcesContent":[".widget-light-theme {\n    --widget-bg: #fff;\n    --sermon-heading: #000;\n    --notification-menu: #fff;\n    --noti-cont-shadow: 1px 1px 10px gray;\n    --chat-head-bg: #fff;\n    --song-cont-bg: #d8d8d8;\n    --selected-event: rgba(255, 255, 255, 0.85);\n    --event-item-shadow: 1px 1px 10px #d1d1d1;\n    --shortcut-menu-bg: #fff;\n    --shoutcut-cont-bg: #818181;\n    --fc-button-primary: rgb(0 0 0 / 60%);\n    --fc-button-primary-dis: rgb(0 0 0 / 80%);\n}\n.widget-dark-theme {\n    --widget-bg: #151515;\n    --sermon-heading: #fff;\n    --notification-menu: #080808;\n    --noti-cont-shadow: unset;\n    --chat-head-bg: #323232;\n    --song-cont-bg: #1d1e1e;\n    --selected-event: unset;\n    --event-item-shadow: unset;\n    --shortcut-menu-bg: #080808;\n    --shoutcut-cont-bg: #18191a;\n    --fc-button-primary: rgb(255 255 255 / 0.1);\n    --fc-button-primary-dis: rgb(255 255 255 / 0.3);\n}\n\n.sharp-mode {\n    --max-width: 100%;\n    --width: calc(100%);\n}\n\n.round-mode {\n    --max-width: 95%;\n    --width: calc(95%);\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    background-color: #080808;\n    overflow-x: hidden;\n}\n\nhtml {\n    /* background-color: #080808 !important; */\n    overflow-x: hidden !important;\n}\n\n.rightWrapMain {\n    width: var(--width);\n    padding-top: 20px;\n    overflow-y: auto;\n}\n\n@media (max-width: 500px) {\n    .rightWrapMain {\n        width: 90% !important;\n    }\n}\n\n.rightWrapMain::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.mainWrapper {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    /* height: 100vh; */\n    min-height: 100vh;\n}\n.video-banner-bg {\n    background: url(../../assets/images/home-video-bg.png) center/cover\n        no-repeat;\n    height: 450px;\n    border-radius: 20px;\n}\n.banner-title h2 {\n    color: #fff;\n    font-size: 40px;\n    line-height: 54px;\n    font-family: \"frontageregular\";\n}\n.video-banner-bg {\n    display: flex;\n    align-items: flex-end;\n    padding: 20px;\n    position: relative;\n}\n.tag-name {\n    display: table;\n    position: relative;\n}\n.tag-name h4 {\n    margin: 0;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    padding: 8px 16px;\n    position: relative;\n    z-index: 10;\n}\n.blur-bg {\n    background: rgb(150 150 150 / 40%);\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 9;\n    filter: blur(0.8px);\n    border-radius: 3px;\n}\n.banner-title {\n    margin-top: 10px;\n}\n.play-btn {\n    position: absolute;\n    z-index: 12;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.play-btn i {\n    color: #fff;\n    font-size: 100px;\n}\n.messages-list {\n    height: 84%;\n    overflow: hidden;\n}\n.messages-list {\n    height: 84%;\n    overflow: hidden;\n    padding: 20px;\n}\n.messages-list ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.messages-list li span {\n    color: #3478ff;\n    font-family: \"frontageregular\";\n    opacity: 1;\n    margin-bottom: 1px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 600;\n    display: block;\n}\n.messages-list li {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    opacity: 0.6;\n    font-size: 15px;\n    line-height: 22px;\n}\n.messages-list li + li {\n    margin-top: 15px;\n}\n.typing-msg {\n    border-top: 1px solid rgb(255 255 255 / 10%);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 16%;\n    padding: 0 20px;\n}\n.typbox input {\n    background: 0 0;\n    border: none;\n    outline: 0;\n    font-family: \"Open Sans\", sans-serif;\n    padding: 0;\n    color: #fff;\n    opacity: 0.6;\n}\n.typbox {\n    width: 70%;\n}\n.btn-submit {\n    width: 30%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.btn-submit input {\n    width: auto;\n    background: #3478ff;\n    border: none;\n    color: #fff;\n    padding: 6px 20px;\n    outline: 0;\n    display: flex;\n}\n.take-note-field textarea {\n    background: 0 0;\n    width: 100%;\n    height: 100%;\n    outline: 0;\n    border: none;\n    padding: 25px;\n    resize: none;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    height: 100%;\n}\n.take-note-field {\n    height: 100%;\n}\n.take-notes-inner {\n    height: 100%;\n    background: #171717;\n    border-radius: 20px 0 0 20px;\n}\n.editdeletebtn {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    display: flex;\n    align-items: center;\n    opacity: 0;\n}\n.hover-div {\n    /* ... existing styles */\n    transition: all 0.3s ease; /* Adjust duration and timing as needed */\n}\n.hovered {\n    /* ... existing hover styles */\n    opacity: 1;\n}\n\n.sidebaroption.hide,\n.sidebaroption2.hide {\n    display: none;\n}\n\n.custom-widgetMain.show {\n    display: block;\n}\n.editbtn {\n    margin-left: 12px;\n}\n.msg-inner-box {\n    position: relative;\n}\n.editdeletebtn img {\n    cursor: pointer;\n}\n.bluegradientmain {\n    padding: 15px 30px 15px 30px;\n    position: relative;\n    border-radius: 20px;\n    height: 100%;\n    user-select: none;\n    background-position: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.bluegradientmain::-webkit-scrollbar {\n    width: 4px !important;\n    display: none !important;\n}\n\n.bluegradientmain::-webkit-scrollbar-track {\n    background: transparent; /* Color of the track */\n}\n.bluegradientmain::-webkit-scrollbar-thumb {\n    background: #414040; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n.edit-mode {\n    outline: 4px dashed #d60909;\n}\n\n.videoCont {\n    border-radius: 20px;\n    height: 100%;\n    width: 100%;\n    user-select: none;\n}\n\n.videoDiv {\n    background-image: url(../../assets//images/redefineKidz.png);\n    background-size: cover;\n    height: 100%;\n    width: 100%;\n    border-radius: 20px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.aspect-ratio-box {\n    height: 0;\n    overflow: hidden;\n    padding-top: 56.25%;\n    background: white;\n    position: relative;\n    border-radius: 20px;\n}\n.aspect-ratio-box-inside {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(../../assets//images/redefineKidz.png);\n    background-size: cover;\n}\n\n/* For controls panel customization*/\n/* video::-webkit-media-controls-panel {\n  background-image: none !important;\n  margin-bottom: 30px;\n } */\n\n.imgBg {\n    /* background-image: url(../../assets//images/blackBg.jpg); */\n    padding: 30px;\n    position: relative;\n    border-radius: 20px;\n    width: 100%;\n    /* height: calc(328px * 2 + 25px); */\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    user-select: none;\n}\n\nh2.quoteText {\n    font-size: 40px;\n    color: #ffffff;\n    text-align: center;\n}\n\nh2.maintitle {\n    color: #fff;\n    font-size: 34px;\n    line-height: 44px;\n    font-family: \"frontageregular\";\n}\n.sec2 {\n    margin-top: 30px;\n}\n.give-form input {\n    background: 0 0;\n    border: none;\n    outline: 0;\n    border-bottom: 1px solid #fff;\n    border-radius: 0;\n    padding: 12px 0;\n    width: 100%;\n    color: #fff;\n    font-size: 13px;\n    padding: 15px 0;\n    /* margin-bottom: 18px; */\n}\n\n.logout-textarea {\n    background: 0 0;\n    border: none;\n    outline: 0;\n    border-bottom: 1px solid #fff;\n    border-radius: 0;\n    padding: 12px 0;\n    width: 100%;\n    color: #fff;\n    font-size: 13px;\n    padding: 15px 0;\n    max-height: 120px;\n}\n\n.giving-btn-cont {\n    margin-top: 1rem;\n}\n\n.donated-amount {\n    color: #fb5f5f;\n    font-weight: 600;\n    letter-spacing: 4px;\n    margin: 0;\n    opacity: 0.9;\n}\n\n.payment-method-cont {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    cursor: pointer;\n    padding: 10px;\n    background-color: #f46363;\n    border-radius: 12px;\n    row-gap: 6px;\n    min-height: 86px;\n    position: relative;\n}\n\n.freq-goal-cont {\n    border-radius: 5px;\n    padding-block: 6px;\n    padding-inline: 14px;\n    cursor: pointer;\n}\n\n.giving-mobile::-webkit-scrollbar {\n    display: none;\n}\n\n.chat-bubble {\n    max-width: 70% !important;\n}\n\n.chatHead-chat-bubble {\n    max-width: 90% !important;\n}\n\n@media (max-width: 468px) {\n    .logout-textarea {\n        margin: 0 !important;\n        padding-bottom: 0 !important;\n    }\n    .bluegradientmain {\n        zoom: 90% !important;\n    }\n    .bluegradientmain-mobile {\n        padding: 12px !important;\n    }\n    .giving-mobile {\n        padding: 10px !important;\n        overflow: auto;\n    }\n    .pinkgradient {\n        zoom: 90% !important;\n    }\n    .giving-amount-field {\n        padding: 0 !important;\n    }\n    .giving-btn-cont {\n        margin-top: 0.25rem;\n    }\n    .donated-amount {\n        line-height: 1.2;\n        font-size: 36px !important;\n    }\n    .songs-list {\n        padding: 12px !important;\n        zoom: 90%;\n    }\n    .calendar,\n    .team-detail {\n        zoom: 80%;\n    }\n    .fc-col-header {\n        width: 100% !important;\n    }\n    .fc-scrollgrid-sync-table,\n    .fc-daygrid-body-unbalanced {\n        width: 100% !important;\n    }\n    .team-member {\n        zoom: 90%;\n        padding: 10px !important;\n    }\n    .profile-name {\n        margin-top: 0 !important;\n    }\n    .givingPaddingFlag {\n        padding: 10px !important;\n    }\n    .subscription-text {\n        font-size: 10px !important;\n    }\n    .reoccuringGifts {\n        height: 80px !important;\n    }\n    .payment-method-cont,\n    .ach-card-cont {\n        min-height: 56px !important;\n        padding: 6px !important;\n        border-radius: 6px !important;\n    }\n    .givingGoal,\n    .joinGroup {\n        padding: 10px !important;\n    }\n    .freq-goal-cont {\n        padding-inline: 8px;\n    }\n    .profileText h4 {\n        line-height: 1.4 !important;\n    }\n    .chat-bubble {\n        max-width: 98% !important;\n    }\n}\n\n/* Customize the scrollbar width */\ntextarea::-webkit-scrollbar {\n    width: 6px; /* Width of the entire scrollbar */\n}\n/* Customize the track (the background of the scrollbar) */\ntextarea::-webkit-scrollbar-track {\n    background: transparent; /* Color of the track */\n}\n/* Customize the thumb (the draggable part of the scrollbar) */\ntextarea::-webkit-scrollbar-thumb {\n    background: #696767; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n/* Customize the thumb when hovered */\ntextarea::-webkit-scrollbar-thumb:hover {\n    background: #555; /* Color of the thumb on hover */\n}\n\ntextarea::-webkit-input-placeholder {\n    color: #fff;\n}\n\n/* Customize the scrollbar width */\nbody::-webkit-scrollbar {\n    width: 4px; /* Width of the entire scrollbar */\n}\n/* Customize the track (the background of the scrollbar) */\nbody::-webkit-scrollbar-track {\n    background: transparent; /* Color of the track */\n}\n/* Customize the thumb (the draggable part of the scrollbar) */\nbody::-webkit-scrollbar-thumb {\n    background: #696767; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n/* Customize the thumb when hovered */\nbody::-webkit-scrollbar-thumb:hover {\n    background: #555; /* Color of the thumb on hover */\n}\n\nbody::-webkit-input-placeholder {\n    color: #fff;\n}\n\n.give-content3-inner.home-about-form .give-form input {\n    padding: 15px 0;\n    margin-bottom: 18px;\n}\n.submit-btn-give input {\n    background: #fff;\n    font-size: 18px;\n    padding: 4px 20px !important;\n    border-radius: 2px;\n    letter-spacing: -2px;\n    width: auto;\n    margin-top: 10px;\n    color: #397bfe;\n    margin-bottom: 0 !important;\n    font-family: \"frontageregular\";\n    border-radius: 7px;\n}\n.give-form input::-webkit-input-placeholder {\n    color: #fff;\n}\n.give-form input:-ms-input-placeholder {\n    color: #fff;\n}\n.give-form input::placeholder {\n    color: #fff;\n}\n.welcomForm.give-form {\n    /* margin-top: 30px; */\n}\n.pinkgradient {\n    /* background: #f8acac; */\n    /* background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%); */\n    position: relative;\n    border-radius: 20px;\n    /* overflow: hidden; */\n    height: 100%;\n    user-select: none;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    overflow-y: auto;\n}\n.pinkgradient::-webkit-scrollbar {\n    display: none;\n    /* width:0.5rem; */\n}\n\n.welcomForm.give-form .formField.halffield {\n    width: 40%;\n}\n\n.amount-Input {\n    border-bottom: 1px solid #fff;\n    align-items: center;\n    column-gap: 10px;\n}\n\n.welcomForm.give-form .submit-btn-give.halffield {\n    width: 40%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.fullfield {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.submit-btn-give.halffield input {\n    margin: 0 0 18px;\n    color: #fb7878;\n}\n.pinkTop {\n    /* padding: 0 20px 0 20px; */\n    padding: 20px;\n    height: 40%;\n    /* padding-bottom: 15px; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.whitebottom {\n    height: 60%;\n    background: #fff;\n    padding: 10px;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n}\n\n.contentcenter {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    height: 100%;\n    /* margin-left: 60px; */\n    justify-content: space-between;\n}\n\n.contentcenter h2 {\n    color: #fb6d6d;\n    font-size: 60px;\n    line-height: 74px;\n    font-family: \"frontageregular\";\n}\n\n.contentcenter h3 {\n    color: #fb6d6d;\n    font-size: 30px;\n    line-height: 44px;\n    font-family: \"frontageregular\";\n}\n\n.contentcenter h6 {\n    color: #000;\n    font-weight: 600;\n    font-size: 18px;\n    margin-top: 15px;\n}\n.progessbar {\n    width: 60px;\n    height: 90%;\n    background: rgb(23 23 23 / 20%);\n    position: absolute;\n    top: 0;\n    border-radius: 10px;\n    top: 5%;\n    overflow: hidden;\n}\n\n.whitebottom {\n    position: relative;\n}\n\n.progessbar:before {\n    content: \"\";\n    background: #f8acac;\n    background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%);\n    width: 100%;\n    height: 80%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\n.sec3 {\n    margin-top: 30px;\n}\n.purplegradientmain {\n    /* background: #d5afff; */\n    /* background: linear-gradient(149deg, #d5afff 0, #9d53f1 100%); */\n    padding: 30px;\n    position: relative;\n    border-radius: 20px;\n    transition: background-image 0.5s ease, background-size 0.5s ease;\n    height: 100%;\n    user-select: none;\n    /* background-image: url(../../assets/images/mapDiv.png); */\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n/* .purplegradientmain:hover {\n  background-image: url(../../assets//images/map.png);\n  background-size: cover;\n} */\n\n.joinGroup {\n    background: #d5afff;\n    /* background: linear-gradient(149deg, #d5afff 0, #9d53f1 100%); */\n    padding: 30px;\n    position: relative;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    user-select: none;\n}\n\n.eventList {\n    background: #f57b4f;\n    /* background: linear-gradient(149deg, #f57b4f 0, #d94d2e 100%); */\n    padding: 30px;\n    position: relative;\n    border-radius: 20px;\n    display: flex;\n    height: 100%;\n    user-select: none;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    overflow: auto;\n}\n\n.eventList::-webkit-scrollbar {\n    display: none;\n}\n\n.date-range {\n    background: rgb(150 150 150 / 40%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    padding-inline: 20px;\n    height: 30px;\n}\n\n.datetimegroup h3 {\n    color: #fff;\n    font-size: 46px;\n    line-height: 54px;\n    font-family: \"frontageregular\";\n}\n\n.textbottomgroup p {\n    color: #000;\n    font-weight: 600;\n    font-size: 18px;\n    margin-top: 15px;\n    margin: 0;\n}\n\n.datetimegroup {\n    margin: 40px 0;\n}\n.orangegradientmain {\n    background: #f57b4f;\n    /* background: linear-gradient(149deg, #f57b4f 0, #d94d2e 100%); */\n    padding: 30px;\n    position: relative;\n    border-radius: 20px;\n    height: 100%;\n    user-select: none;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.orangeimage {\n    position: absolute;\n    right: 30px;\n    top: 30px;\n}\n\n.orangeimage img {\n    max-width: 230px;\n}\n.rightInnerWrap {\n    /* border: 2px solid #777778; */\n    padding: 0 20px 20px 20px;\n    max-width: var(--max-width);\n    margin: 0 auto;\n    transition: 0.3s;\n    margin-bottom: 50px;\n}\n.sec3,\n.sec2 {\n    transition: 0.3s;\n}\n.rightInnerWrap .container {\n    max-width: 100%;\n    padding: 0;\n}\n/* Kits */\n.widgetToolBar {\n    background: #2d2d2d;\n    border-radius: 8px;\n    border: 1px solid #727272;\n    position: relative;\n}\n\n.widgetToolbarInner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px;\n}\n\n.toolBarRight {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-left: 10px;\n}\n\n.toolBarRight > div + div {\n    margin-left: 18px;\n}\n\n.toolBarLeft h4 {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 14px;\n    margin: 0;\n    line-height: 20px;\n    text-transform: uppercase;\n}\n\n.kits {\n    margin-top: 30px;\n}\n.widgetToolBar:before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #2d2d2d;\n    position: absolute;\n    bottom: -10px;\n    left: 10px;\n    z-index: 99;\n}\n\n.widgetToolBar:after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #727272;\n    position: absolute;\n    bottom: -11px;\n    left: 10px;\n    z-index: 98;\n}\n.space {\n    height: 30px;\n}\n.colorCircle span {\n    display: table;\n    width: 27px;\n    height: 27px;\n    border-radius: 100%;\n}\n.colorCircle span.white {\n    background: #fff;\n}\n.colorCircle span.blue {\n    background: #3478ff;\n}\n.fontList select {\n    border: 1px solid #969696;\n    background: #2d2d2d;\n    height: 29px;\n    padding: 2px 3px;\n    font-size: 13px;\n}\n.widgetuploadinner img {\n    width: 100%;\n}\n\n.widgetEditBox {\n    background: #18191a;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 30px;\n}\n\n.editTitle {\n    color: #fff;\n}\n\n.editTitle a.BlueButton {\n    margin: 0;\n}\n\n.editTitle h3 {\n    margin-bottom: 18px;\n}\n\n.editTitle p {\n    margin-bottom: 28px;\n}\n.custom-widgetMain {\n    display: none;\n}\n.mainsideBar::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n/* Kits End */\n@media (min-width: 1200px) and (max-width: 1700px) {\n    .mainsideBar {\n        width: 360px;\n    }\n    .rightInnerWrap {\n        max-width: var(--max-width);\n    }\n    .rightWrapMain {\n        width: var(--width);\n        padding-top: 20px;\n        overflow-y: auto;\n    }\n    .themelayoutinnerbox span,\n    .BlueButton,\n    .customthemelayoutinnerbox span {\n        font-size: 14px;\n    }\n    .banner-title h2 {\n        font-size: 30px;\n        line-height: 42px;\n    }\n    h2.maintitle {\n        font-size: 28px;\n        line-height: 40px;\n    }\n    .datetimegroup h3 {\n        font-size: 34px;\n        line-height: 44px;\n    }\n}\n\n/* 90% */\n@media (min-width: 1700px) {\n    .rightInnerWrap {\n        max-width: var(--max-width) !important;\n    }\n}\n/* 80% */\n@media (min-width: 1920px) {\n    .rightInnerWrap {\n        max-width: var(--max-width) !important;\n    }\n}\n/* 75% */\n@media (min-width: 2048px) {\n    .rightInnerWrap {\n        max-width: var(--max-width) !important;\n    }\n}\n\n@media (max-width: 700px) {\n    .rightInnerWrap {\n        padding: 0 !important;\n    }\n}\n\n.react-resizable-handle .react-resizable-handle-se {\n    width: 100px;\n    background-color: red;\n}\n\n.connectTextarea {\n    user-select: none;\n    resize: none;\n    overflow-wrap: break-word;\n    border-color: transparent;\n    background-color: transparent;\n    width: 70%;\n}\n\n.editText {\n    outline: -webkit-focus-ring-color auto 1px;\n}\n\n.joinTextarea {\n    overflow: hidden;\n    user-select: none;\n    max-width: 500px;\n    overflow-wrap: break-word;\n    border-color: transparent;\n    background-color: transparent;\n    width: 70%;\n}\n.ourCodeTextarea {\n    width: 90%;\n    max-height: 500px;\n    background-color: transparent;\n    border-color: transparent;\n    overflow-wrap: break-word;\n    user-select: none;\n    overflow: hidden;\n}\n\n/* Custom Widget */\n.customWidget {\n    display: flex;\n    height: 100%;\n    background-color: rgb(210, 167, 167);\n    /* background: linear-gradient(90deg, #0062ff, #da61ff); */\n    padding: 20px;\n    overflow: hidden;\n}\n\n.input-container {\n    position: relative;\n}\n\n.aligned-input {\n    position: absolute;\n}\n\n.aligned-button {\n    position: absolute;\n}\n\n.topCenter {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    margin: 20px;\n}\n\n.bottomCenter {\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    margin: 20px;\n}\n\n.topLeft {\n    top: 0;\n    left: 0;\n    margin: 20px;\n}\n\n.bottomLeft {\n    bottom: 0;\n    left: 0;\n    margin: 20px;\n}\n\n.bottomRight {\n    bottom: 0;\n    right: 0;\n    margin: 20px;\n}\n\n.topRight {\n    top: 0;\n    right: 0;\n    margin: 20px;\n}\n.center {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    /* margin: 20px; */\n    /* margin-inline: 20px; */\n}\n\n.centerLeft {\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    margin-left: 20px;\n}\n\n.centerRight {\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    margin-right: 20px;\n}\n.divtext {\n    border: ridge 2px;\n    padding: 5px;\n    width: 10em;\n    min-height: 2em;\n}\nspan[contentEditable=\"true\"]:empty:before {\n    content: attr(data-placeholder);\n    color: #b1a4a4; /* Set placeholder color */\n}\n\n.css-o4b71y-MuiAccordionSummary-content {\n    width: 100%;\n}\n\n.firstCol {\n    overflow-y: scroll;\n    width: calc((100%) / 3);\n}\n\n.firstColRound {\n    width: calc((100% - 40px) / 3);\n}\n\n.firstCol::-webkit-scrollbar {\n    display: none;\n}\n\n.secondCol {\n    overflow-y: scroll;\n    width: calc((100%) / 3);\n}\n.secondColRound {\n    width: calc((100% - 40px) / 3);\n}\n\n.secondCol::-webkit-scrollbar {\n    display: none;\n}\n.thirdCol {\n    overflow-y: scroll;\n    width: calc((100%) / 3);\n}\n.thirdColRound {\n    width: calc((100% - 40px) / 3);\n}\n\n.thirdCol::-webkit-scrollbar {\n    display: none;\n}\n\n.firstRow {\n    overflow-y: scroll;\n}\n\n.firstRow::-webkit-scrollbar {\n    display: none;\n}\n\n.secondRow {\n    overflow-y: scroll;\n}\n\n.secondRow::-webkit-scrollbar {\n    display: none;\n}\n.thirdRow {\n    overflow-y: scroll;\n}\n\n.thirdRow::-webkit-scrollbar {\n    display: none;\n}\n\n.header-Icon {\n    height: 30px;\n    width: 25px;\n    max-width: 25px;\n}\n\nheader.newHeader {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n}\nheader.newHeader {\n    position: relative;\n    background: #171717;\n}\n\nheader.newHeader .row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\nheader.newHeader .container-fluid {\n    padding: 6px 50px;\n}\nheader.newHeader.blueHeader .cirlenoti {\n    border: 2px solid #3478ff;\n}\n\n@media (max-width: 767px) {\n    header.newHeader .container-fluid {\n        padding: 0 24px;\n    }\n    .newheaderRight {\n        width: 80% !important;\n        justify-content: flex-end;\n        display: none !important;\n    }\n    .mobileMenuDesign .admin-dashboard-left h3 {\n        font-family: \"Open Sans\", sans-serif;\n        color: #fff;\n        opacity: 0.5;\n        font-size: 16px;\n        margin-bottom: 10px;\n    }\n    .openmobilemenu,\n    .closeMenu {\n        display: block !important;\n    }\n    .footer-b-left p {\n        padding: 0 20px;\n        font-size: 14px;\n        text-align: center;\n        line-height: 18px;\n    }\n}\n\n.noti-wrapper {\n    margin-top: 30px;\n}\n\n@media (max-width: 768px) {\n    .header-Logo {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding-block: 10px;\n    }\n    .mainHeader {\n        display: none !important;\n    }\n    .leftCol {\n        padding: 0 !important;\n    }\n    .header.newHeader .row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .modal-Btn {\n        /* background-color: #fff; */\n        min-width: 100px !important;\n    }\n    .outer-border {\n        width: 30px !important;\n        height: 30px !important;\n    }\n    .go-back {\n        justify-content: center !important;\n    }\n    .sec2Btns {\n        justify-content: center !important;\n    }\n    .float {\n        right: 40px !important;\n    }\n    .header-shortcut-nav {\n        display: none !important;\n    }\n\n    .column-Widget {\n        flex-direction: column !important;\n        width: 100% !important;\n        row-gap: 20px !important;\n    }\n    .firstCol {\n        width: 100% !important;\n        padding-bottom: 50px !important;\n    }\n    .secondCol {\n        width: 100% !important;\n    }\n    .thirdCol {\n        width: 100% !important;\n    }\n    .annual-budget-heading {\n        font-size: 18px;\n    }\n\n    .team-right-col {\n        width: 100%;\n        padding-left: 0 !important;\n    }\n    .event-detail-cont {\n        width: 100%;\n    }\n    .team-detail {\n        row-gap: 10px;\n    }\n    .event-detail-cont {\n        border-bottom-right-radius: 15px !important;\n    }\n    .eventList {\n        padding: 10px !important;\n    }\n    .notifications-cont {\n        height: 70vh !important;\n    }\n    .noti-wrapper {\n        margin-top: unset !important;\n    }\n    .noti-back {\n        margin-block: 20px;\n    }\n}\n\n.newheaderRight {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.newiconheader {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.newiconheader > div {\n    margin-left: 18px;\n}\n.profileIMg {\n    position: relative;\n}\n\n@media (max-width: 850px) {\n    .mobileMenuDesign .admin-dashboard-left h3 {\n        font-family: \"Open Sans\", sans-serif;\n        color: #fff;\n        opacity: 0.5;\n        font-size: 16px;\n        margin-bottom: 10px;\n    }\n    .admin-dashboard-left {\n        width: calc(100% - 30px) !important;\n        margin: 0 auto !important;\n        background: transparent !important;\n        padding: 12px 0 !important;\n    }\n    .header-menu.newmenuDesign ul li a {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .header-menu.newmenuDesign ul li a {\n        margin: 0 auto;\n        text-align: center;\n        padding: 0;\n        height: 110px;\n        overflow: hidden;\n        border-radius: 10px;\n    }\n\n    .header-menu.newmenuDesign ul li a img {\n        margin: 0 0 9px;\n        max-width: 35px;\n    }\n\n    .header-menu.newmenuDesign ul li {\n        width: 48%;\n        margin: 0;\n        background: #18191a;\n        border-radius: 10px;\n        margin-bottom: 4%;\n    }\n\n    .header-menu.newmenuDesign ul {\n        display: flex;\n        flex-direction: initial;\n        flex-wrap: wrap;\n        padding: 0;\n        align-items: center;\n        justify-content: start;\n    }\n\n    .header-menu.newmenuDesign ul li:nth-child(2n) {\n        margin-left: 4%;\n    }\n    .header-main .header-menu ul {\n        display: flex;\n        flex-direction: column;\n        align-items: self-start;\n        padding: 21px 0px;\n        width: calc(100% + 30px);\n        position: absolute;\n        left: -30px;\n        background: #18191a;\n        top: 45px;\n        padding: 22px 10px;\n        display: none;\n    }\n\n    .header-main .header-menu ul li {\n        margin: 0;\n    }\n\n    .header-main .header-menu ul li + li {\n        margin-top: 12px;\n    }\n    .redefineText {\n        font-size: 34px !important;\n    }\n    .header-Icon {\n        max-width: 100% !important;\n    }\n    .icons-container {\n        padding-block: 4px;\n    }\n    .header-Logo img {\n        height: 34px !important;\n    }\n}\n\n.mobileMenuDesign {\n    position: absolute;\n    width: 300px;\n    right: -4px;\n    top: 100%;\n    padding-top: 10px;\n    z-index: 999999;\n    /* display: none; */\n    max-height: 0px;\n    transition: max-height 0.5s ease-out;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.mobileMenuDesign.open {\n    max-height: 600px;\n    pointer-events: all;\n}\n\n.mobileMenuDesign .header-menu.newmenuDesign ul li a {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.mobileMenuDesign .header-menu.newmenuDesign ul li a {\n    margin: 0 auto;\n    text-align: center;\n    padding: 0;\n    height: 110px;\n    overflow: hidden;\n    border-radius: 10px;\n}\n\n.mobileMenuDesign .header-menu.newmenuDesign ul li a img {\n    margin: 0 0 9px;\n    max-width: 35px;\n}\n\n.mobileMenuDesign .header-menu.newmenuDesign ul li {\n    width: 48%;\n    margin: 0;\n    background: var(--shoutcut-cont-bg);\n    border-radius: 10px;\n    margin-bottom: 4%;\n}\n\n.mobileMenuDesign .header-menu.newmenuDesign ul {\n    display: flex;\n    flex-direction: initial;\n    flex-wrap: wrap;\n    padding: 0;\n    align-items: center;\n    justify-content: start;\n}\n\n.mobileMenuDesign .header-menu.newmenuDesign ul li:nth-child(2n) {\n    margin-left: 4%;\n}\n.mobileMenuDesign .admin-dashboard-left {\n    width: 100%;\n    background: var(--shortcut-menu-bg) !important;\n    padding: 20px !important;\n    border-radius: 12px;\n    position: relative;\n    /* box-shadow: var(--event-item-shadow); */\n}\n\n.mobileMenuDesign .admin-dashboard-left h3 {\n    font-size: 14px;\n    margin-bottom: 12px;\n    color: var(--sermon-heading);\n}\n\n.profileIMg:hover .mobileMenuDesign .admin-dashboard-left:before {\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid black;\n    content: \"\";\n    position: absolute;\n    top: -4px;\n    right: 13px;\n}\n\n.profileIMg:hover .mobileMenuDesign {\n    max-height: 550px;\n    pointer-events: all;\n    overflow: auto;\n    border-radius: 12px;\n    box-shadow: var(--event-item-shadow);\n}\n\n.mobileMenuDesign::-webkit-scrollbar {\n    display: none;\n}\n\n.admin-dashboard-left {\n    width: 280px;\n    background: #0e0e0e;\n    padding: 20px 0;\n    margin-left: 40px;\n    border-radius: 12px;\n}\n.admin-dashboard-left {\n    margin-left: 0px;\n    border-radius: 0;\n}\n\n.top-menu-inner ul,\n.admin-dashboard-left,\n.songsList,\n.for-box-innner {\n    background: #18191a !important;\n}\n\n.dropdownnewpro {\n    background: var(--shoutcut-cont-bg);\n    padding: 12px;\n    /* margin-bottom: 20px; */\n    border-radius: 8px;\n}\n.innerdropdownmain {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.innerdropdownmainLEft img {\n    width: 35px;\n    border-radius: 100%;\n    height: 35px;\n}\n\n.innerdropdownmainLEft a {\n    display: flex;\n    align-items: center;\n    color: #fff;\n}\n\n.innerdropdownmainLEft h5 {\n    margin: 0;\n    font-size: 15px;\n    margin-left: 10px;\n}\n.angledownopenmenu {\n    width: 25px;\n    height: 25px;\n    background: #2a2b2d;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100%;\n}\n.angledownopenmenu.activeang i.fa {\n    transform: rotate(180deg);\n}\n.menuDropinner ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid #2b2b2b;\n}\n\n.menuDropinner ul li a {\n    color: #fff !important;\n    padding: 0;\n}\n.menuDropinner ul li + li {\n    margin-top: 8px;\n}\n.menuDropinner {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.5s ease-out;\n}\n\n.menuDropinner ul li img,\n.menuDropinner ul li i.fa {\n    min-width: 21px;\n}\n\n.menuDropinner.open {\n    max-height: 180px; /* Adjust this value to be greater than the maximum height of your menu */\n    pointer-events: all;\n}\n\n.header-menu-main-left ul {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.header-menu-main-left ul li + li {\n    margin: 0;\n    margin-top: 12px;\n}\n\n.header-menu-main-left .header-menu {\n    justify-content: flex-start;\n    width: 100%;\n}\n\n.header-menu-main-left ul li a::before {\n    display: none;\n}\n\n.header-menu-main-left ul li a {\n    display: block;\n    width: 100%;\n    padding: 18px;\n    border-radius: 0;\n}\n\n.header-menu-main-left ul li {\n    width: 100%;\n}\nheader {\n    background: #0e0e0e;\n}\n.header-menu-main-left ul li.active a,\n.header-menu-main-left ul li:hover a {\n    background: #3478ff;\n    color: #fff;\n}\n\n.header-menu.newmenuDesign {\n    /* padding-top: 14px; */\n}\n\n.header-menu ul li + li {\n    margin-left: 50px;\n}\n.header-menu ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.header-menu ul li a {\n    color: #6a6a6a;\n    font-size: 21px;\n    text-decoration: none;\n    transition: 0.3s;\n}\n.header-menu ul li a:hover {\n    color: #3478ff;\n}\n.header-menu ul li {\n    margin: 0 0;\n}\n.header-menu ul li a {\n    font-size: 18px !important;\n}\n.header-menu ul li + li {\n    margin-left: 30px;\n}\n\n.header-menu.newmenuDesign ul li a {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n}\n\n.header-menu.newmenuDesign ul li a img {\n    margin-right: 12px;\n}\n\n.header-menu.newmenuDesign ul li a span {\n    position: relative;\n    top: 1px;\n}\n.openmobilemenu,\n.closeMenu {\n    display: none !important;\n}\n\n/*footer*/\ndiv#footer-sec {\n    background: #171717;\n}\n.fullpage-nav div#footer-sec {\n    margin-top: 30px;\n}\n.has-footer-bottom {\n    border-top: 1px solid rgb(255 255 255 / 5%);\n}\n.footer-bottom .row {\n    display: flex;\n    align-items: center;\n}\n.footer-bottom {\n    padding: 25px 0;\n}\n.footer-b-left p {\n    color: #fff;\n    opacity: 0.4;\n    font-size: 18px;\n    line-height: 26px;\n}\n.footer-b-right ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.footer-b-right ul li a i {\n    color: #fff;\n    font-size: 24px;\n    opacity: 0.4;\n}\n.footer-b-right ul li + li {\n    margin-left: 10px;\n}\n\n.login-modal {\n    background: linear-gradient(70deg, #128dff -0.46%, #be00ee 98.67%);\n    border-radius: 20px;\n    background-color: transparent;\n}\n\n.modal-content {\n    background-color: transparent;\n    border: unset;\n}\n\n.cancel-modal {\n    border-radius: 20px;\n    background-color: #fff;\n}\n\n.welcomText {\n    font-size: 34px;\n    color: white;\n    font-weight: 500;\n    line-height: 34px;\n}\n.redefineText {\n    font-size: 44px;\n    font-weight: 700;\n    color: #fff;\n    line-height: 54px;\n}\n.footerText {\n    line-height: 24px;\n    font-size: 18px;\n    color: #fff;\n}\n\n.modal-Btn {\n    background-color: transparent;\n    border-radius: 50px;\n    border: 1px solid #fff;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    /* width: 170px; */\n    padding-block: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n}\n\n.modal-Btn:hover {\n    background-color: #fff;\n}\n\n.modal-Btn span {\n    color: white;\n}\n\n.modal-Btn:hover span {\n    color: #2d27fc;\n}\n\n.modal-input {\n    border-radius: 40px;\n    background: rgba(23, 23, 23, 0.05);\n    border: none;\n    box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.2) inset;\n    color: #fff;\n    font-size: 14px;\n    padding: 18px 20px;\n    outline: none;\n    width: 100%;\n}\ninput::placeholder {\n    /* For modern browsers */\n    color: #fff;\n}\n\n.forgot-pass {\n    color: #fff;\n    font-size: 13px;\n    margin-top: 10px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n\n.go-back {\n    cursor: pointer;\n}\n.go-back span {\n    color: #fff;\n}\n\n.outer-border {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100px;\n    border: 1px solid #fff;\n    height: 50px;\n    width: 50px;\n}\n.circleDot {\n    height: 13px;\n    width: 13px;\n    background-color: #fff;\n    border-radius: 50px;\n}\n\n.outerCircle {\n    height: 18px;\n    width: 18px;\n    border: 1px solid #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n}\n\n.outerCircleHide {\n    border: unset !important;\n}\n\n.watchSelect {\n    background-color: transparent;\n    outline: unset;\n    border: unset;\n    color: #fff;\n    padding-block: 4px;\n    border-bottom: 1px solid #fff;\n}\n\n.gift-type {\n    color: #fff;\n    font-weight: 600;\n}\n\n.react-datepicker__close-icon::after {\n    background-color: transparent;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n    top: 7px;\n    padding-left: 0 !important;\n}\n.date-input {\n    padding-inline: 30px !important;\n}\n\n/* Switch.css */\n.switch-container {\n    display: inline-block;\n}\n\n.switch-checkbox {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n    position: absolute;\n    transition: 0.4s; /* Smooth background color transition */\n}\n\n.switch-label {\n    display: block;\n    width: 50px;\n    height: 25px;\n    background: #ececec;\n    border-radius: 100px;\n    position: relative;\n    cursor: pointer;\n    transition: background-color 0.4s ease; /* Smooth background color transition */\n}\n\n.switch-label .switch-button {\n    display: block;\n    width: 23px;\n    height: 23px;\n    background: #fb6262;\n    border-radius: 50%;\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    transition: transform 0.4s ease 0.1s; /* Smooth transform transition with delay */\n}\n\n.switch-checkbox:checked + .switch-label .switch-button {\n    transform: translateX(25px);\n}\n\n.switch-checkbox:checked + .switch-label {\n    background: #ececec;\n}\n\n/* Swich Rules */\n\n@media (max-width: 768px) {\n    .togSwichCls {\n        justify-content: flex-start !important;\n    }\n}\n\n.togSwichCls .switch input {\n    display: none;\n}\n.togSwichCls .switch {\n    display: inline-block;\n    width: 55px;\n    height: 26px;\n    transform: translateY(14%);\n    position: relative;\n}\n/* Style Wired */\n.togSwichCls .slider {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 30px;\n    cursor: pointer;\n    overflow: hidden;\n    transition: 0.4s;\n    background-color: #ececec;\n    border: 1px solid #fbfbfb;\n}\n.togSwichCls .slider:before {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #8b8b8b;\n    border-radius: 30px;\n    transform: translateX(2px);\n    transition: 0.4s;\n    width: 22px;\n    height: 22px;\n    margin-top: 1px;\n}\n\n.togSwichCls input:checked + .slider:before {\n    transform: translateX(30px);\n    background: #fb6262;\n}\n\n@media (max-width: 400px) {\n    .togSwichCls input:checked + .slider:before {\n        transform: translateX(25px) !important;\n    }\n}\n\n/* video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 20px;\n}\n.video-react.video-react-fluid {\n  height: 100% !important;\n}\n.video-react {\n  position: unset !important;\n  display: contents !important;\n} */\n\nvideo {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 20px;\n}\n.video-react {\n    position: unset !important;\n    display: contents !important;\n}\n.video-react.video-react-fluid {\n    padding-top: 56.25% !important;\n    height: 100% !important;\n}\n\n.float {\n    position: fixed;\n    right: 170px;\n    bottom: 40px;\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 6px;\n    cursor: pointer;\n}\n\n.login-caution {\n    background-color: #0f101d;\n    padding: 12px 20px;\n    border-radius: 9px;\n}\n\n.login-caution:after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid transparent;\n    border-left: 15px solid #0f101d;\n    right: -12px;\n    position: absolute;\n    top: 10px;\n}\n\n.header-Logo {\n    display: none;\n}\n\n.live-gif {\n    position: absolute;\n    width: 100px;\n    height: 50px;\n    top: 0;\n    right: 130px;\n    z-index: 1;\n}\n\n@media (max-width: 768px) {\n    .header-Logo {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding-block: 10px;\n    }\n    .mainHeader {\n        display: none !important;\n    }\n    .leftCol {\n        padding: 0 !important;\n    }\n    .header.newHeader .row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .live-gif {\n        right: 50px !important;\n        /* width: 80px !important; */\n    }\n    .logout-mian-header {\n        padding-inline: 0rem !important;\n    }\n}\n\n@media (max-width: 465px) {\n    .live-gif {\n        right: 30px !important;\n        width: 80px !important;\n    }\n    .outline-Text {\n        font-size: 34px !important;\n    }\n    .contentcenter h3 {\n        font-size: 20px !important;\n    }\n}\n\n.graph-select {\n    border-radius: 5px;\n    background-color: transparent;\n    color: #fff;\n    border-color: #fff;\n    position: absolute;\n    right: 60px;\n    border: 1px solid #fff;\n    outline: unset;\n    padding-block: 4px;\n}\n\n@media (max-width: 560px) {\n    .graph-select {\n        right: 20px !important;\n        top: 10px !important;\n        padding: 0;\n        font-size: 14px;\n    }\n    .echarts-for-react {\n        zoom: 80% !important;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .live-gif {\n        right: 60px !important;\n        width: 80px !important;\n    }\n}\n\n@media (max-width: 450px) {\n    .live-gif {\n        right: 20px !important;\n        width: 65px !important;\n        height: 30px !important;\n    }\n}\n\n/* Customize the scrollbar width */\n.chat-Section::-webkit-scrollbar {\n    /* display: none; */\n    width: 3px; /* Width of the entire scrollbar */\n    height: 3px;\n}\n/* Customize the track (the background of the scrollbar) */\n.chat-Section::-webkit-scrollbar-track {\n    background: transparent; /* Color of the track */\n}\n/* Customize the thumb (the draggable part of the scrollbar) */\n.chat-Section::-webkit-scrollbar-thumb {\n    background: #696767; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n/* Customize the thumb when hovered */\n.chat-Section::-webkit-scrollbar-thumb:hover {\n    background: #555; /* Color of the thumb on hover */\n}\n\n.chat-Section {\n    padding: 6px;\n}\n\n.input-container {\n    border: 2px solid rgb(100, 160, 240); /* Initial border color */\n    border-radius: 10px;\n    box-shadow: 0 0 1px rgb(100, 175, 240), 0 0 5px rgb(100, 160, 240),\n        0 0 1px rgb(100, 160, 240), 1px 0 1px rgb(100, 160, 240),\n        0 0 1px rgb(100, 160, 240), 0 0 1px rgb(100, 160, 240),\n        0 0 5px rgb(100, 160, 240);\n}\n\n.broadcast {\n    height: 25px;\n    width: 25px;\n    transform: rotate(-30deg);\n}\n\n.sermon-Cont,\n.mobile-sermon-Cont {\n    background-color: var(--widget-bg);\n    height: 100%;\n    padding: 10px;\n    overflow: hidden;\n    justify-content: space-between;\n    column-gap: 4px;\n    border-radius: 20px;\n}\n\n.sermon-section {\n    row-gap: 10px;\n    margin-top: 6px;\n    overflow: auto;\n    height: 100%;\n}\n\n.sermon-section::-webkit-scrollbar {\n    display: none;\n}\n\n.sermon-series-section {\n    row-gap: 10px;\n    margin-top: 6px;\n    overflow: auto;\n    height: 100%;\n}\n\n.sermon-series-section::-webkit-scrollbar {\n    display: none;\n}\n\n.sermon-heading {\n    color: var(--sermon-heading);\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0;\n}\n\n@media (max-width: 1000px) {\n    .sermon-series-wrapper {\n        width: 49%;\n    }\n    .sermon-wrapper {\n        width: 49%;\n    }\n}\n\n@media (max-width: 800px) {\n    .sermon-Cont {\n        flex-direction: column !important;\n        overflow: auto !important;\n        height: -webkit-fill-available !important;\n    }\n    .mobile-sermon-Cont {\n        zoom: 90%;\n    }\n    .sermon-series-wrapper {\n        width: 100% !important;\n    }\n    .sermon-wrapper {\n        width: 100% !important;\n    }\n    .sermon-series-section {\n        height: 200px !important;\n    }\n    .sermon-section {\n        height: 200px !important;\n    }\n}\n\n.header-heading {\n    cursor: pointer;\n    color: var(--sermon-heading);\n}\n\n.logout-mian-header {\n    padding-inline: 3rem;\n}\n\n.admin-dashboard-left ul li {\n    margin-bottom: 10px;\n    color: var(--sermon-heading);\n}\n\n.topPart {\n    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n}\n\n.giveButton {\n    background-color: #fff;\n    padding: 10px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    border-radius: 6px;\n    width: 40%;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Hide increment and decrement buttons in Firefox */\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n/* .rs-progress-line-outer {\n  height: 140px !important;\n} */\n\n.rs-progress.rs-progress-line.rs-progress-line-vertical {\n    height: 100%;\n}\n\n.giving {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    border-radius: 15px;\n    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);\n    height: 100%;\n    padding: 20px;\n}\n\n.givingInput {\n    color: #ffffff;\n    background-color: transparent;\n    outline: unset;\n    border: unset;\n}\n.givingInput::placeholder {\n    color: #ffffff;\n}\n.givingInput2 {\n    color: #ffffff;\n    background-color: transparent;\n    outline: unset;\n    border: unset;\n}\n\n.givingInput2::placeholder {\n    color: grey;\n}\n\n.goalInput {\n    color: #ffffff;\n    background-color: transparent;\n    outline: unset;\n    border: unset;\n}\n.goalInput::placeholder {\n    color: grey;\n}\n\n.toggle-switch {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 24px;\n}\n\n.toggle-switch input {\n    display: none;\n}\n\n.toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    border-radius: 34px;\n    transition: 0.4s;\n}\n\n.toggle-slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 2px;\n    bottom: 2px;\n    background-color: grey;\n    border-radius: 50%;\n    transition: 0.4s;\n}\ninput:checked + .toggle-slider {\n    /* background-color: #2196F3; */\n}\n\ninput:checked + .toggle-slider:before {\n    transform: translateX(26px);\n    background-color: #fa7373;\n}\n\n.system-toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    border-radius: 34px;\n    transition: 0.4s;\n    width: 45px;\n}\n\n.system-toggle-slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 2px;\n    bottom: 2px;\n    background-color: grey;\n    border-radius: 50%;\n    transition: 0.4s;\n}\n\ninput:checked + .system-toggle-slider:before {\n    transform: translateX(20px);\n    background-color: #3478ff;\n}\n\n.givingGoal {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    padding: 20px;\n    overflow: auto;\n}\n\n.givingGoal::-webkit-scrollbar {\n    display: none;\n}\n\n.give-banner {\n    background-image: url(../../assets/images/give-banner-img.png);\n    height: calc(100vh - 86px);\n    margin-top: 50px;\n    padding-bottom: 20px;\n    width: 100%;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.give-banner.group-banner {\n    background-image: url(../../assets/images/group-page-top-banner.png);\n}\n\n.give-banner.serve-banner {\n    background-image: url(../../assets/images/serve.png);\n}\n.give-banner.kids-banner {\n    background-image: url(../../assets/images/redefine-kids-bg.png);\n}\n.give-banner.about-banner {\n    background-image: url(../../assets/images/about-bg.png);\n    margin-top: 0 !important;\n}\n\n.parent-div {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr); /* Four equal columns */\n    gap: 10px; /* Gap between the grid items */\n    margin: 10px; /* Optional: Margin around the grid */\n    width: 95%;\n    overflow: auto;\n    padding-inline: 4px;\n}\n\n.parent-div::-webkit-scrollbar {\n    width: 0.1em !important;\n    /* display: none; */\n}\n\n.parent-div::-webkit-scrollbar {\n    width: 2px; /* Width of the entire scrollbar */\n    background: transparent;\n    border-radius: 10px;\n}\n/* Customize the track (the background of the scrollbar) */\n.parent-div::-webkit-scrollbar-track {\n    background: \"#fff\"; /* Color of the track */\n}\n/* Customize the thumb (the draggable part of the scrollbar) */\n.parent-div::-webkit-scrollbar-thumb {\n    background: #000; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n/* Customize the thumb when hovered */\n.parent-div::-webkit-scrollbar-thumb:hover {\n    background: #000; /* Color of the thumb on hover */\n}\n\n.child-div {\n    padding: 20px;\n    text-align: center;\n}\n\n.padding-zero{\n    padding: 0 !important;\n}\n\n@media (max-width: 1000px) {\n    .parent-div {\n        display: flex;\n        flex-wrap: wrap; /* Enable wrapping on smaller screens */\n    }\n\n    .child-div {\n        flex: 1 1 calc(50% - 20px); /* Make each div take 50% width minus gap */\n    }\n}\n\n@media (max-width: 480px) {\n    .child-div {\n        flex: 1 1 calc(100% - 20px); /* Make each div take full width minus gap */\n    }\n}\n.outline-Text {\n    -webkit-text-stroke: 2px #fa7373;\n    -webkit-text-fill-color: transparent;\n\n    /* fallback */\n    color: #fb6d6d;\n    font-family: \"Roboto\", sans-serif;\n    /* text-align: center; */\n    font-size: 54px;\n}\n\n.inputCont {\n    border-bottom: 1px solid #fff;\n    justify-content: space-between;\n}\n\n.react-datepicker__input-container input {\n    width: 98% !important;\n    background-color: transparent;\n    font-size: 12px;\n    color: #fff;\n    outline: unset;\n    border: unset;\n}\n\n.react-datepicker-popper .react-datepicker__triangle {\n    display: none;\n}\n.react-datepicker {\n    left: 30%;\n}\n\n.ach-card-cont {\n    min-height: 86px;\n}\n\n@media screen and (max-width: 1440px) {\n    .paymentMethods {\n        height: 220px !important;\n    }\n    .payment-method-cont,\n    .ach-card-cont {\n        min-height: 86px !important;\n    }\n}\n\n@media screen and (max-width: 460px) {\n    .paymentMethods {\n        height: 120px !important;\n    }\n}\n\n.paymentMethods {\n    height: 200px;\n    overflow-y: scroll;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding-inline: 4px;\n    padding-block: 10px;\n}\n.paymentMethods::-webkit-scrollbar {\n    width: 0.2em !important;\n    /* display: none; */\n}\n\n.paymentMethods::-webkit-scrollbar {\n    width: 4px; /* Width of the entire scrollbar */\n    background: #000;\n    border-radius: 10px;\n}\n/* Customize the track (the background of the scrollbar) */\n.paymentMethods::-webkit-scrollbar-track {\n    background: \"#fff\"; /* Color of the track */\n}\n/* Customize the thumb (the draggable part of the scrollbar) */\n.paymentMethods::-webkit-scrollbar-thumb {\n    background: #fff; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n/* Customize the thumb when hovered */\n.paymentMethods::-webkit-scrollbar-thumb:hover {\n    background: #fff; /* Color of the thumb on hover */\n}\n\n.parent {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* Four equal columns */\n    gap: 10px; /* Gap between the grid items */\n    width: 100%;\n    overflow: auto;\n}\n\n.child {\n    padding: 10px;\n    /* text-align: center; */\n}\n\n@media (max-width: 1000px) {\n    .parent {\n        display: flex;\n        flex-wrap: wrap; /* Enable wrapping on smaller screens */\n    }\n\n    .child {\n        flex: 1 1 calc(50% - 20px); /* Make each div take 50% width minus gap */\n    }\n}\n\n@media (max-width: 480px) {\n    .child {\n        flex: 1 1 calc(100% - 20px); /* Make each div take full width minus gap */\n    }\n}\n\n.reoccuringGifts {\n    height: 120px;\n    overflow-y: auto;\n    row-gap: 4px;\n    padding-inline: 4px;\n}\n.reoccuringGifts::-webkit-scrollbar {\n    width: 0.2em !important;\n}\n\n.reoccuringGifts::-webkit-scrollbar {\n    width: 4px; /* Width of the entire scrollbar */\n    background: #000;\n    border-radius: 10px;\n}\n/* Customize the track (the background of the scrollbar) */\n.reoccuringGifts::-webkit-scrollbar-track {\n    background: \"#fff\"; /* Color of the track */\n}\n/* Customize the thumb (the draggable part of the scrollbar) */\n.reoccuringGifts::-webkit-scrollbar-thumb {\n    background: #fff; /* Color of the thumb */\n    border-radius: 10px; /* Rounded corners */\n}\n/* Customize the thumb when hovered */\n.reoccuringGifts::-webkit-scrollbar-thumb:hover {\n    background: #fff; /* Color of the thumb on hover */\n}\n\n.subscriptionItem {\n    background: linear-gradient(120deg, #d4d0d0 0, #ffd5d3 100%);\n    border-radius: 6px;\n    padding: 14px;\n}\n\n.react-datepicker-wrapper {\n    width: 90% !important;\n}\n\n.confirmation-dialog {\n    box-shadow: 2px 2px 2px 2px rgb(84 75 75 / 50%);\n}\n\n.groupList {\n    height: 100%;\n    background-image: url(../../assets/images/group-banner.png);\n    background-size: cover;\n    background-repeat: no-repeat;\n    overflow: auto;\n}\n\n.groupList::-webkit-scrollbar {\n    width: 2px;\n}\n\n.teamList {\n    height: 100%;\n    background-image: url(../../assets/images/kids.png);\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.songs-list {\n    display: flex;\n    height: 100%;\n    background-color: #fff;\n    flex-direction: column;\n    padding: 20px;\n    overflow: hidden;\n    box-shadow: var(--noti-cont-shadow);\n}\n\n.team-member {\n    display: flex;\n    padding: 20px;\n    height: 100%;\n    /* background-color: #171717; */\n    background-color: var(--widget-bg);\n    align-items: center;\n    justify-content: center;\n    box-shadow: var(--noti-cont-shadow);\n}\n\n.profile-name {\n    text-align: center;\n    color: var(--sermon-heading);\n    font-size: 18px;\n    margin-top: 16px;\n    font-weight: 500;\n    font-family: sans-serif;\n    text-transform: capitalize;\n    cursor: pointer;\n}\n\n.profile-name:hover {\n    text-decoration-line: underline;\n    text-decoration-color: #007bff;\n}\n\n.profile-icon {\n    height: 60px;\n    width: 60px;\n    object-fit: contain;\n}\n\n.calendar {\n    height: 100%;\n    overflow: hidden;\n    box-shadow: var(--noti-cont-shadow);\n}\n\n.team-detail {\n    height: 100%;\n    overflow: scroll;\n    box-shadow: var(--noti-cont-shadow);\n}\n\n.team-detail::-webkit-scrollbar {\n    display: none;\n}\n\n.title-text {\n    font-size: 18px;\n    margin: 0px;\n    color: var(--sermon-heading) !important;\n    font-family: sans-serif;\n}\n\n.sub-text {\n    font-family: sans-serif;\n    font-size: 14px;\n    margin: 0px;\n    color: #a5a5a5 !important;\n}\n\n.team-right-col::-webkit-scrollbar {\n    display: none;\n}\n\n.imageInnerText h4 {\n    margin: 0px;\n    font-size: 13px;\n    line-height: 20px;\n    font-family: sans-serif;\n    font-weight: 600;\n}\n\n.imageInnerText {\n    position: absolute;\n    bottom: 0px;\n    color: #fff;\n    padding: 15px;\n    background: rgb(0 0 0 / 44%);\n    width: 100%;\n    border-bottom-right-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.selected-event {\n    border-radius: 15px;\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    cursor: pointer;\n}\n\n.unselected-event {\n    border-radius: 15px;\n    cursor: pointer;\n}\n\n/* .selected-event:before {\n    content: \"\";\n    position: absolute;\n    z-index: 99999;\n    background: url(../../assets/images/bar.png) no-repeat;\n    left: -10px;\n    top: -14px;\n    width: 15px;\n    height: 268px;\n    border-radius: 0;\n    background-size: cover;\n    background-position: center left;\n    filter: brightness(0);\n} */\n\n.selected-event {\n    position: relative;\n}\n\n.selected-event:before {\n    content: \"\";\n    position: absolute;\n    z-index: 1;\n    background: url(../../assets/images/bar.png) no-repeat;\n    left: -10px;\n    top: -14px;\n    width: 15px;\n    height: 268px;\n    border-radius: 0;\n    background-size: cover;\n    background-position: center left;\n}\n\n.selected-event:after {\n    content: \"\";\n    position: absolute;\n    z-index: 2;\n    left: -10px;\n    top: -14px;\n    width: 15px;\n    height: 268px;\n    background-color: var(--selected-event);\n    mix-blend-mode: screen;\n}\n\n.songs-cont::-webkit-scrollbar {\n    display: none;\n}\n\n.accept-btn {\n    background-color: #28a830;\n    border-radius: 3px;\n    padding: 6px;\n    color: #fff;\n    font-size: 14px;\n}\n\n.decline-btn {\n    background-color: #ff3434;\n    border-radius: 3px;\n    padding: 6px;\n    color: #fff;\n    font-size: 14px;\n}\n\n.song-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out,\n        padding-top 0.3s ease-in-out;\n    opacity: 0;\n    padding-top: 0;\n}\n\n.song-content.open {\n    opacity: 1;\n    padding-top: 10px;\n}\n\n.song-info-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out,\n        padding 0.3s ease-in-out;\n    opacity: 0;\n    padding-top: 0;\n}\n\n.song-info-content.open {\n    opacity: 1;\n    padding: 20px;\n    max-height: 500px;\n}\n\n.additional-data {\n    color: #000;\n    min-width: 30%;\n}\n\n.track-cont {\n    overflow: auto;\n}\n\n.track-cont::-webkit-scrollbar {\n    display: none;\n}\n\n/* .slider {\n  border-radius: 0 !important;\n} */\n\n.team-blur-footer {\n    position: absolute;\n    bottom: 0px;\n    padding: 18px;\n    padding-left: 30px;\n    left: 0px;\n    width: 100%;\n    background: rgba(37, 37, 37, 0.6);\n    backdrop-filter: blur(7.5px);\n    align-items: flex-start;\n}\n\n.event-detail-cont {\n    flex-direction: column;\n    /* background-color: #171717; */\n    background-color: var(--widget-bg);\n    border-radius: 15px;\n    padding: 15px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.event-detail-cont div img {\n    object-fit: cover;\n    height: 200px;\n    width: 100%;\n    border-radius: 10px;\n}\n\n.event-img {\n    border-radius: 10px;\n    height: 220px;\n    width: 100%;\n    object-fit: cover;\n}\n\n.event-name {\n    color: var(--sermon-heading);\n    font-weight: bold;\n    margin: 0;\n    margin-bottom: 4px;\n}\n\n.event-item-cont {\n    background-color: var(--widget-bg);\n    min-height: 240px;\n    position: relative;\n    padding: 10px;\n    box-shadow: var(--event-item-shadow);\n}\n\n.song-cont {\n    background-color: var(--song-cont-bg);\n    padding-block: 15px;\n    padding-left: 20px;\n    align-items: center;\n    cursor: pointer;\n}\n.song-cont span {\n    color: var(--sermon-heading) !important;\n    font-size: 16px;\n    font-family: sans-serif;\n    margin-inline: 30px;\n}\n\n.carousel-root {\n    width: 100%;\n}\n\n.option-parent {\n    overflow-x: scroll;\n    height: 100%;\n    justify-content: space-between;\n}\n\n.option-parent::-webkit-scrollbar {\n    display: none;\n}\n\n.option-cont {\n    background-color: #464748;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 180px;\n    padding: 16px;\n    cursor: pointer;\n}\n.option-cont.selected {\n    background-color: #fff;\n}\n\n.option-cont span {\n    color: #bababa;\n    font-size: 16px;\n}\n\n.option-cont.selected span {\n    color: #000;\n}\n\n.arrangement-option {\n    background-color: #000;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    padding: 10px;\n    border-radius: 10px;\n    min-height: 35px;\n    min-width: 150px;\n}\n\n.arrangement-option h6 {\n    color: #fff;\n}\n\n.youtube-cont {\n    background: red;\n    border-radius: 7px;\n    text-align: center;\n    padding: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    max-width: 100px;\n}\n\n.youtube-cont h6 {\n    color: #fff;\n    font-size: 14px;\n}\n\n.serve-block {\n    background-color: #f57b4f;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    padding-block: 60px;\n    margin-bottom: 60px;\n    row-gap: 50px;\n}\n\n.about-us {\n    padding: 20px;\n    width: 90%;\n    justify-content: space-between;\n    padding-block: 80px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n}\n\n@media (max-width: 768px) {\n    .about-us {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    .grid-images {\n        grid-template-columns: repeat(1, 1fr) !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .about-us {\n        grid-template-columns: 1fr;\n    }\n    .leadership-img {\n        height: 300px !important;\n        /* background-position: center; */\n        background-size: cover !important;\n    }\n    .serve-block p {\n        font-size: 12px !important;\n        line-height: 14px !important;\n    }\n    .serve-block h3 {\n        font-size: 20px !important;\n        line-height: 20px !important;\n    }\n    .give-banner {\n        height: 300px !important;\n    }\n    .give-banner h1 {\n        font-size: 24px !important;\n    }\n    .leadership-img p {\n        font-size: 10px !important;\n    }\n    .budget-resource-h3 {\n        font-size: 18px !important;\n        line-height: 1.3 !important;\n    }\n}\n\n.our-leadership {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    padding-block: 30px;\n    padding-inline: 20px;\n    font-family: sans-serif;\n}\n\n.leadership-img {\n    border-radius: 20px;\n    height: 600px;\n    align-items: center;\n    justify-content: flex-end;\n    display: flex;\n    /* background-position: center; */\n    background-size: cover;\n    flex-direction: column;\n}\n\n.grid-images {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    margin-top: 40px;\n}\n\n.leadership-img h2,\n.leadership-img p {\n    background-color: rgba(255, 255, 255, 0.5);\n    color: #000;\n    font-family: sans-serif;\n    font-weight: 600;\n    text-align: center;\n    padding-inline: 4px;\n    line-height: unset;\n    margin-inline: 10px;\n    border-radius: 2px;\n}\n\n.leadership-img h2 {\n    font-size: 22px;\n    margin-bottom: 30px;\n}\n\n.leadership-img p {\n    font-size: 14px;\n    padding: 8px;\n    border-radius: 10px;\n    text-align: justify;\n}\n\n.header-shortcut-nav a:hover {\n    text-decoration-line: underline !important;\n    text-decoration-color: #fff !important;\n}\n\n.bottom-border {\n    border-bottom-left-radius: 15px !important;\n    border-bottom-right-radius: 15px !important;\n}\n\n.budget-resource-h3 {\n    color: #fa7373;\n    font-weight: bold;\n    margin: 0;\n}\n\n.fc.fc-media-screen.fc-direction-ltr.fc-theme-standard {\n    height: 100%;\n    background-color: var(--widget-bg);\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n    padding: 10px 10px 0 10px;\n}\n\n.fc .fc-daygrid-day-top {\n    flex-direction: row !important;\n}\n\n.fc-daygrid-event {\n    border-radius: 0;\n}\n\n.day-number {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 10px;\n    border-radius: 50px;\n    height: 24px;\n    width: 24px;\n}\n\n.day-number h5 {\n    color: var(--sermon-heading);\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.fc .fc-daygrid-day-number {\n    text-decoration: none;\n}\n\n.fc .fc-col-header-cell-cushion {\n    color: grey;\n}\n\n.fc-h-event .fc-event-title-container {\n    text-align: center;\n}\n\n.fc-theme-standard th {\n    border: unset;\n    border-bottom: 1px solid #2d2d2d !important;\n}\n\n.fc-scroller {\n    overflow: auto !important;\n}\n.fc-scroller::-webkit-scrollbar {\n    display: none !important;\n}\n\n.fc .fc-scroller-liquid-absolute {\n    overflow: auto !important;\n}\n\n.fc .fc-scroller-liquid-absolute::-webkit-scrollbar {\n    width: 0.1em !important;\n    background-color: transparent !important;\n    height: 0.1em !important;\n}\n\n.fc .fc-scroller-liquid-absolute::-webkit-scrollbar-thumb {\n    width: 0.1em !important;\n    background-color: rgba(43, 43, 43, 0) !important;\n}\n\n.fc .fc-scroller-liquid-absolute::-webkit-scrollbar-track {\n    background-color: transparent !important;\n}\n\n.fc-theme-standard .fc-scrollgrid {\n    border: unset !important;\n    border-width: 0px !important;\n}\n\n.fc .fc-button-primary {\n    background-color: var(--fc-button-primary);\n    text-transform: capitalize;\n}\n\n.fc .fc-button-primary:disabled {\n    background-color: var(--fc-button-primary-dis);\n    opacity: 0.4;\n}\n\n.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child),\n.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {\n    border: unset !important;\n    box-shadow: none;\n}\n\n.fc-theme-standard td {\n    border: 1px solid #2d2d2d;\n}\n\n.fc-scrollgrid-sync-inner {\n    text-align: left;\n}\n\n.fc-popover {\n    background-color: #131516 !important;\n}\n\n@media (max-width: 468px) {\n    .fc-popover {\n        top: unset !important;\n        left: unset !important;\n        transform: translate(20%, 20%);\n    }\n    .group-list-title {\n        font-size: 22px !important;\n        line-height: 1.2 !important;\n    }\n    .group-list-desp {\n        font-size: 12px !important;\n        line-height: 1.2 !important;\n    }\n}\n\n@media (max-width: 350px) {\n    .fc-popover {\n        transform: translate(10%, 10%);\n    }\n}\n\n.fc-theme-standard .fc-list {\n    border: unset !important;\n}\n\n:root {\n    --fc-list-event-hover-bg-color: #42424233 !important;\n}\n\n.fc .fc-list-empty {\n    background-color: #5c55554d;\n}\n\n.fc-theme-standard .fc-list-day-cushion {\n    background-color: hsl(0deg 0% 18.43%);\n}\n\n.fc-more-popover-misc {\n    display: none;\n}\n\n.logout-giving-cont {\n    overflow: scroll;\n    height: 100%;\n    justify-content: space-between;\n}\n\n.logout-giving-cont::-webkit-scrollbar {\n    display: none !important;\n}\n\n.inputs-wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n}\n\n@media (max-width: 768px) {\n    .inputs-wrapper {\n        grid-template-columns: 1fr; /* On smaller devices, single column */\n    }\n}\n\n.single-widget-cont::-webkit-scrollbar {\n    width: 0.5rem !important;\n}\n\n.notes-cont::-webkit-scrollbar {\n    width: 0.5rem !important;\n}\n\n.video-chat-cont::-webkit-scrollbar {\n    width: 0.5 !important;\n}\n\n@media (max-width: 768px) {\n    .fc-button-group {\n        flex-wrap: wrap !important;\n    }\n    .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {\n        flex-wrap: wrap !important;\n        zoom: 80% !important;\n    }\n}\n\n.text-span::-webkit-scrollbar {\n    width: 2px !important;\n}\n\n.chat-wrapper {\n    height: 100vh;\n    display: flex;\n    overflow: hidden;\n    width: 100%;\n}\n\n.conversation-sidebar {\n    transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;\n    width: 320px;\n    overflow: hidden;\n    left: 0;\n    height: 90vh;\n    background-color: white;\n}\n\n.convo-cont::-webkit-scrollbar {\n    width: 2px;\n}\n\n.messages-wrapper::-webkit-scrollbar {\n    width: 2px;\n}\n\n.message-cont::-webkit-scrollbar {\n    width: 2px;\n}\n\n.convo-item {\n    cursor: pointer;\n    border-bottom: 1px solid #4f4c4c;\n    align-items: center;\n    display: flex;\n}\n\n.notifications-cont {\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    padding-right: 4px;\n    height: 75vh;\n}\n\n.notifications-cont::-webkit-scrollbar {\n    width: 4px;\n}\n.notifications-cont::-webkit-scrollbar-thumb {\n    width: 4px;\n    background-color: gray;\n    border-radius: 10px;\n}\n\n.notification-menu {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    border-radius: 10px;\n    width: 320px;\n    max-height: 70vh;\n    background-color: var(--notification-menu);\n    padding: 20px;\n    right: -40px;\n    top: 40px;\n    box-shadow: var(--noti-cont-shadow);\n}\n.noti-profile-img {\n    height: 56px;\n    width: 56px;\n    object-fit: cover;\n    border-radius: 100px;\n}\n\n.noti-icon-img {\n    height: 28px;\n    width: 28px;\n    object-fit: contain;\n    border-radius: 100px;\n    position: absolute;\n    bottom: -2px;\n    right: -10px;\n}\n\n.all-read-ellipsis {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 30px;\n    width: 30px;\n    border-radius: 100px;\n}\n.all-read-ellipsis:hover {\n    background-color: #3c3c3c;\n    cursor: pointer;\n}\n/* .noti-item:hover {\n    background-color: #353535 !important;\n    cursor: pointer;\n} */\n\n.chat-head-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    height: 50px;\n    width: 50px;\n    background-color: var(--chat-head-bg);\n    border-radius: 10px;\n    box-shadow: var(--noti-cont-shadow);\n}\n\n.chat-head-wrapper {\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    position: fixed;\n    bottom: 10px;\n    right: 25px;\n    z-index: 1;\n\n    /* overflow: auto; */\n    /* width: calc(100vw - 80px); */\n}\n\n.chat-head-wrapper::-webkit-scrollbar {\n    height: 4px;\n}\n\n.chat-head-wrapper::-webkit-scrollbar-track {\n    background: transparent !important;\n}\n\n.chat-head-wrapper::-webkit-scrollbar-thumb {\n    background: #414040; /* Color of the thumb */\n    border-radius: 10px;\n}\n\n@media (max-width: 468px) {\n    .chat-head-wrapper {\n        display: none !important;\n    }\n}\n\n.chat-head-seacrh::-webkit-input-placeholder {\n    color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
